import React, { useEffect, useState, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import {
  FiChevronDown,
  FiChevronRight,
  FiEye,
  FiMoreVertical,
  FiCamera,
  FiX,
} from "react-icons/fi";
import { FaSave, FaPencilAlt, FaTimes,FaChartBar } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import SummaryApi from "../common";
import { decodeCourseId } from "../utils/encoder";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import skillaraLogo from "../asset/certificate/skillara-logo.png";
import ribbonImage from "../asset/certificate/ribbon.png";
import googleLogo from "../asset/certificate/google.png";
import microsoftLogo from "../asset/certificate/microsoft.png";
import greatBadge from "../asset/certificate/great.png";
import awsPath from "../asset/certificate/aws.png";
// Add these functions to your component
import { useNavigate } from "react-router-dom"; // Add this import if not already there
import skillaraBg from "../asset/certificate/bg.png";
const InstructorCurriculum = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const timeSlotId = queryParams.get("time_slot_id");
  const batchName = queryParams.get("batch_name");
  const { id } = useParams();
  const courseId = decodeCourseId(id);
  const instructorId = Number(sessionStorage.getItem("instructor_id"));
  const studentId = Number(sessionStorage.getItem("student_id"));
  const [enrolledStudents, setEnrolledStudents] = useState([]);
  const [activeTab, setActiveTab] = useState("course-schedule");
  const [dynamicTimeSlotId, setDynamicTimeSlotId] = useState(
    timeSlotId ? Number(timeSlotId) : null
  );
  const [dynamicBatchName, setDynamicBatchName] = useState(batchName);
  const [course, setCourse] = useState(null);
  const [curriculum, setCurriculum] = useState([]);
  const [lessonsByCurriculum, setLessonsByCurriculum] = useState({});
  const [closedLessons, setClosedLessons] = useState([]);
  const [closedTopics, setClosedTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataReady, setDataReady] = useState(false);
  const [closedLoaded, setClosedLoaded] = useState(false);
  const [openCurriculumId, setOpenCurriculumId] = useState(null);
  const [showAssignmentModal, setShowAssignmentModal] = useState(false);
  const [selectedLessonId, setSelectedLessonId] = useState(null);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState("");
  const [assignments, setAssignments] = useState([]);
  const [showAssignmentDetails, setShowAssignmentDetails] = useState(false);
  const [viewedAssignment, setViewedAssignment] = useState(null);
  const [dropdownLessonId, setDropdownLessonId] = useState(null);
  const [timeSlotDetails, setTimeSlotDetails] = useState(null);
  const [project, setProject] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [showProjectModal, setShowProjectModal] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);
  const [topics, setTopics] = useState([]);
  const [topicLessons, setTopicLessons] = useState([]);
  const dropdownRefs = useRef({});
  const navigate = useNavigate();
// Add this with other useState declarations
const [showAssignmentScoreModal, setShowAssignmentScoreModal] = useState(false);
const [selectedStudentForScores, setSelectedStudentForScores] = useState(null);
const [assignmentScores, setAssignmentScores] = useState([]);
const [allAssignments, setAllAssignments] = useState([]);
const [loadingScores, setLoadingScores] = useState(false);
  const [projectLoading, setProjectLoading] = useState(false);
  const [showProjectDetailsModal, setShowProjectDetailsModal] = useState(false);
const [selectedStudentProject, setSelectedStudentProject] = useState(null);
const [isCourseCompleted, setIsCourseCompleted] = useState(false);
  const [projectActive, setProjectActive] = useState(
    project ? project.is_active === 1 : true
  );
  // Assignment form states
  const [courses, setCourses] = useState([]);
  const [questionsMap, setQuestionsMap] = useState({});
  const [currentPage, setCurrentPage] = useState(1); // Add this with other useState
  const recordsPerPage = 5;
  const [formData, setFormData] = useState({
    instructor_id: instructorId || "",
    course_id: courseId || "",
    time_slot_id: dynamicTimeSlotId || "",
    assignment_name: "",
    number_of_questions: "",
    is_active: true,
    assignment_id: "",
    curriculum_id: "",
    lesson_id: "",
  });
  const [questionFormData, setQuestionFormData] = useState({
    question_id: "",
    assignment_id: "",
    course_id: courseId || "",
    question_name: "",
    option_a: "",
    option_b: "",
    option_c: "",
    option_d: "",
    correct_answer: "",
    marks: "",
    is_active: true,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [isQuestionEditing, setIsQuestionEditing] = useState(false);
  const [isQuestionsListModalOpen, setIsQuestionsListModalOpen] =
    useState(false);
  const [currentAssignment, setCurrentAssignment] = useState(null);
  const [selectedStudents, setSelectedStudents] = useState([]);
const isCourseCompletedGlobally = timeSlotDetails?.is_course_completed === 1;
  // Calculate days left based on end_date from timeSlotDetails
  const calculateDaysLeft = () => {
    if (!timeSlotDetails || !timeSlotDetails.end_date) return null;
    const endDate = new Date(timeSlotDetails.end_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const timeDiff = endDate.getTime() - today.getTime();
    const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return daysLeft > 0 ? daysLeft : 0;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Optional: Also scroll to top when the location changes
  }, [location.pathname]);
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  // Add this function to convert images to base64 data URLs
  const convertImageToBase64 = async (imageSrc) => {
    try {
      const response = await fetch(imageSrc);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting image to base64:", error);
      return "";
    }
  };
  const formatImageUrl = (imagePath) => {
    if (!imagePath) return "";
    if (imagePath.startsWith("http")) return imagePath;
    const cleanPath = imagePath.replace(/^[\\/]+/, "");
    const baseUrl = SummaryApi.Images.url.replace("/api", "");
    if (imagePath.includes(baseUrl)) return imagePath;
    return `${baseUrl}/${cleanPath}`;
  };

  const formatTimeDisplay = (timeString) => {
    const time = timeString?.trim();
    if (!time || time === "N/A") return "N/A";
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const twelveHour = hour % 12 || 12;
    return `${twelveHour}:${minutes} ${ampm}`;
  };

  // Fetch course details
  useEffect(() => {
    if (!courseId) {
      setLoading(false);
      return;
    }
    fetch(SummaryApi.coursedetailsById.url, {
      method: SummaryApi.coursedetailsById.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ course_id: Number(courseId) }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          setCourse(data.data);
        } else {
          console.error("Course fetch failed:", data.message);
        }
      })
      .catch((err) => console.error("Failed to fetch course:", err));
  }, [courseId]);

  // Fetch curriculum
  useEffect(() => {
    if (!courseId) return;
    fetch(SummaryApi.getCurriculumByCourseId.url, {
      method: SummaryApi.getCurriculumByCourseId.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ course_id: Number(courseId) }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status && Array.isArray(data.data)) {
          setCurriculum(data.data);
          if (data.data.length > 0) {
            setOpenCurriculumId(data.data[0].curriculum_id);
          }
        } else {
          console.error("Curriculum fetch failed:", data.message);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch curriculum:", err);
      });
  }, [courseId]);

// Optimized: Fetch time slot details directly by time_slot_id
useEffect(() => {
  if (!dynamicTimeSlotId || isNaN(Number(dynamicTimeSlotId))) return;

  const fetchTimeSlotDetails = async () => {
    try {
      const response = await fetch(
        SummaryApi.instructorTimeslotByInstructorIdandtimeslotid.url,
        {
          method: SummaryApi.instructorTimeslotByInstructorIdandtimeslotid.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            time_slot_id: Number(dynamicTimeSlotId)   // Send time_slot_id directly
          }),
        }
      );

      const data = await response.json();

      if (data.status && data.data && data.data.length > 0) {
        const timeSlot = data.data[0]; // Since it's filtered by time_slot_id, take first one
        setTimeSlotDetails(timeSlot);
        setTimeSlots([timeSlot]); // Optional: keep timeSlots as array with 1 item if needed elsewhere
      } else {
        console.warn("No time slot found for time_slot_id:", dynamicTimeSlotId);
        setTimeSlotDetails(null);
      }
    } catch (error) {
      console.error("Failed to fetch time slot details:", error);
      setTimeSlotDetails(null);
    }
  };

  fetchTimeSlotDetails();
}, [dynamicTimeSlotId]); // Only depend on dynamicTimeSlotId now
  // Fetch closed lessons and topics
  useEffect(() => {
    if (!courseId || !dynamicTimeSlotId || isNaN(Number(dynamicTimeSlotId)))
      return;
    setLoading(true);
    Promise.allSettled([
      fetch(SummaryApi.basedontimeslotlessonclosed.url, {
        method: SummaryApi.basedontimeslotlessonclosed.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          course_id: Number(courseId),
          time_slot_id: Number(dynamicTimeSlotId),
        }),
      }).then((res) => res.json()),
      fetch(SummaryApi.gettopicclosed.url, {
        method: SummaryApi.gettopicclosed.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          course_id: Number(courseId),
          time_slot_id: Number(dynamicTimeSlotId),
        }),
      }).then((res) => res.json()),
    ])
      .then(([lessonsResult, topicsResult]) => {
        if (lessonsResult.status === "fulfilled") {
          const data = lessonsResult.value;
          setClosedLessons(
            data.status
              ? (data.data || []).filter(
                  (item) => item && item.lesson_id !== undefined
                )
              : []
          );
        }
        if (topicsResult.status === "fulfilled") {
          const data = topicsResult.value;
          setClosedTopics(
            data.status
              ? (data.data || []).filter(
                  (item) => item && item.curriculum_id !== undefined
                )
              : []
          );
        }
        setClosedLoaded(true);
      })
      .catch((err) => {
        console.error("Failed to fetch closed data:", err);
      })
      .finally(() => setLoading(false));
  }, [courseId, dynamicTimeSlotId]);

  // Fetch lessons for each curriculum
  useEffect(() => {
    if (
      curriculum.length === 0 ||
      !dynamicTimeSlotId ||
      isNaN(Number(dynamicTimeSlotId))
    ) {
      setLessonsByCurriculum({});
      return;
    }
    const fetchLessonsForCurriculum = async () => {
      setLoading(true);
      const lessonsMap = {};
      for (const topic of curriculum) {
        try {
          const response = await fetch(
            SummaryApi.getCourseLessonByCurriculumId.url,
            {
              method: SummaryApi.getCourseLessonByCurriculumId.method,
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ curriculum_id: topic.curriculum_id }),
            }
          );
          const data = await response.json();
          if (data.status && Array.isArray(data.data)) {
            lessonsMap[topic.curriculum_id] = data.data.map((lesson) => {
              const isLessonClosed = closedLessons.some(
                (closed) =>
                  closed.lesson_id === lesson.lesson_id &&
                  closed.curriculum_id === lesson.curriculum_id &&
                  closed.time_slot_id === Number(dynamicTimeSlotId) &&
                  closed.course_id === lesson.course_id &&
                  closed.is_closed === 1
              );
              return {
                ...lesson,
                is_closed: isLessonClosed ? 1 : 0,
                is_submitted: lesson.assignment_id > 0 ? 1 : 0,
              };
            });
          } else {
            lessonsMap[topic.curriculum_id] = [];
          }
        } catch (error) {
          console.error(
            `Failed to fetch lessons for curriculum ${topic.curriculum_id}`,
            error
          );
          lessonsMap[topic.curriculum_id] = [];
        }
      }
      setLessonsByCurriculum(lessonsMap);
      setDataReady(true);
    };
    fetchLessonsForCurriculum().finally(() => setLoading(false));
  }, [curriculum, closedLessons, dynamicTimeSlotId]);

useEffect(() => {
  const fetchAssignments = async () => {
    // Make sure we have both instructorId and courseId
    if (!instructorId || !courseId) {
      console.warn(
        "Missing instructorId or courseId for fetching assignments"
      );
      return;
    }
    try {
      const res = await fetch(SummaryApi.assignmentByCourseId.url, {
        method: SummaryApi.assignmentByCourseId.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          instructor_id: instructorId,
          course_id: Number(courseId), // Already correct here
        }),
      });
      const data = await res.json();
      if (data.status) {
        setAssignments(data.data || []);
      } else {
        toast.error(data.message || "Failed to fetch assignments");
      }
    } catch (err) {
      console.error("Error fetching assignments:", err);
      toast.error("Error fetching assignments. Please try again.");
    }
  };
  // Only fetch if we have both required IDs
  if (instructorId && courseId) {
    fetchAssignments();
  }
}, [instructorId, courseId]);
  // Fetch questions when assignments change
  useEffect(() => {
    if (assignments.length > 0) {
      const fetchQuestions = async () => {
        const newMap = { ...questionsMap };
        for (const assignment of assignments) {
          if (
            !newMap[assignment.assignment_id] ||
            newMap[assignment.assignment_id].length !==
              assignment.number_of_questions
          ) {
            try {
              const res = await fetch(
                SummaryApi.questionary_form_by_assignment.url,
                {
                  method: SummaryApi.questionary_form_by_assignment.method,
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    assignment_id: assignment.assignment_id,
                  }),
                }
              );
              const data = await res.json();
              if (data.status) {
                newMap[assignment.assignment_id] = data.data || [];
              } else {
                newMap[assignment.assignment_id] = [];
              }
            } catch (err) {
              console.error("Error fetching questions for assignment:", err);
              newMap[assignment.assignment_id] = [];
            }
          }
        }
        setQuestionsMap(newMap);
      };
      fetchQuestions();
    } else {
      setQuestionsMap({});
    }
  }, [assignments]);

  useEffect(() => {
    setProjectActive(project ? project.is_active === 1 : true);
  }, [project]);

  // Fetch project details
  useEffect(() => {
    if (!courseId || !dynamicTimeSlotId || isNaN(Number(dynamicTimeSlotId)))
      return;
    fetch(SummaryApi.instructorretrievebasedontimeslotandcourseid.url, {
      method: SummaryApi.instructorretrievebasedontimeslotandcourseid.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        course_id: Number(courseId),
        time_slot_id: Number(dynamicTimeSlotId),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status && data.data && data.data.length > 0) {
          const projectData = data.data[0];
          setProject(projectData);
          if (projectData.project_image) {
            setPreviewImage(formatImageUrl(projectData.project_image));
          } else {
            setPreviewImage(null);
          }
        } else {
          setProject(null);
          setPreviewImage(null);
        }
      })
      .catch((err) => {
        console.error("Failed to fetch project:", err);
        setProject(null);
        setPreviewImage(null);
      });
  }, [courseId, dynamicTimeSlotId]);

  // Handle click outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        Object.values(dropdownRefs.current).every(
          (ref) => ref && !ref.contains(event.target)
        )
      ) {
        setDropdownLessonId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleCurriculum = (id) => {
    setOpenCurriculumId((prevId) => (prevId === id ? null : id));
  };

  // Add this useEffect to fetch enrolled students when the tab is active
  useEffect(() => {
    if (activeTab === "enroll-students" && instructorId && dynamicTimeSlotId) {
      fetchEnrolledStudents();
    }
  }, [activeTab, instructorId, dynamicTimeSlotId]);

  // Add this function to fetch enrolled students
  const fetchEnrolledStudents = async () => {
    if (!instructorId || !dynamicTimeSlotId) return;

    setLoading(true);
    try {
      const response = await fetch(
        SummaryApi.enrollment_retrieve_by_slot_and_instructor.url,
        {
          method: SummaryApi.enrollment_retrieve_by_slot_and_instructor.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            instructor_id: Number(instructorId),
            time_slot_id: Number(dynamicTimeSlotId),
          }),
        }
      );

      const data = await response.json();

      if (data.status && Array.isArray(data.data)) {
        setEnrolledStudents(data.data);
      } else {
        setEnrolledStudents([]);
        console.error("Failed to fetch enrolled students:", data.message);
      }
    } catch (error) {
      console.error("Error fetching enrolled students:", error);
      setEnrolledStudents([]);
    } finally {
      setLoading(false);
    }
  };

  const handleBulkReview = async () => {
    if (selectedStudents.length === 0) {
      toast.warning("Please select at least one student to review");
      return;
    }

    const confirmed = await Swal.fire({
      title: "Confirm Review",
      text: `Are you sure you want to mark ${selectedStudents.length} student${
        selectedStudents.length > 1 ? "s" : ""
      } as reviewed?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#10b981",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Yes, Mark as Reviewed",
      cancelButtonText: "Cancel",
    });

    if (!confirmed.isConfirmed) return;

    try {
      const payload = {
        student_project_id: selectedStudents, // Array of IDs
        is_review: 1,
        instructor_id: instructorId,
      };

      console.log("Sending payload:", payload); // For debugging

      const response = await fetch(
        SummaryApi.instructor_project_review_update.url,
        {
          method: SummaryApi.instructor_project_review_update.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (data.status) {
        toast.success(
          `Successfully marked ${selectedStudents.length} student${
            selectedStudents.length > 1 ? "s" : ""
          } as reviewed`
        );

        // Clear selection and refresh data
        setSelectedStudents([]);
        fetchEnrolledStudents();
      } else {
        toast.error(data.message || "Failed to update review status");
      }
    } catch (error) {
      console.error("Error updating review status:", error);
      toast.error("Error updating review status. Please try again.");
    }
  };

  // Add this function to handle the review submission
  const submitProjectReview = async (studentId, reviewData) => {
    try {
      const response = await fetch(
        SummaryApi.instructor_project_review_update.url,
        {
          method: SummaryApi.instructor_project_review_update.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            student_id: studentId,
            time_slot_id: Number(dynamicTimeSlotId),
            course_id: Number(courseId),
            instructor_id: instructorId,
            review_comments: reviewData.comments,
            is_review: reviewData.is_review,
            review_date: reviewData.review_date,
            project_status:
              reviewData.status === "approve" ? "approved" : "rejected",
          }),
        }
      );

      const data = await response.json();

      if (data.status) {
        Swal.fire({
          icon: "success",
          title: "Review Submitted Successfully!",
          text: `Project has been ${
            reviewData.status === "approve" ? "approved" : "rejected"
          }.`,
          confirmButtonColor: "#10b981",
        });

        // Refresh the enrolled students list
        fetchEnrolledStudents();
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Failed to submit review. Please try again.",
          confirmButtonColor: "#ef4444",
        });
      }
    } catch (error) {
      console.error("Error submitting review:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while submitting the review.",
        confirmButtonColor: "#ef4444",
      });
    }
  };



// Check if all topics are completed
useEffect(() => {
  if (curriculum.length > 0 && closedTopics.length > 0) {
    const allTopicsCompleted = curriculum.every(topic => 
      closedTopics.some(
        closedTopic => 
          closedTopic.curriculum_id === topic.curriculum_id &&
          closedTopic.time_slot_id === Number(dynamicTimeSlotId) &&
          closedTopic.course_id === Number(courseId) &&
          closedTopic.is_closed === 1
      )
    );
    setIsCourseCompleted(allTopicsCompleted);
  } else {
    setIsCourseCompleted(false);
  }
}, [curriculum, closedTopics, dynamicTimeSlotId, courseId]);




const handleCompleteCourse = async () => {
  if (!dynamicTimeSlotId || isNaN(Number(dynamicTimeSlotId))) {
    toast.error("Invalid time slot");
    return;
  }

  const confirmed = await Swal.fire({
    title: "Complete Course?",
    text: "Are you sure you want to mark this course as completed? This action cannot be undone.",
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#10b981",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Yes, Complete Course",
    cancelButtonText: "Cancel",
  });

  if (!confirmed.isConfirmed) return;

  try {
    const payload = {
      time_slot_id: Number(dynamicTimeSlotId),
      is_course_completed: 1,
    };

    const response = await fetch(SummaryApi.coursecompleteupdate.url, {
      method: SummaryApi.coursecompleteupdate.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (data.status) {
      toast.success("Course marked as completed successfully!");
      
      // Update time slot details to reflect completion
      if (timeSlotDetails) {
        setTimeSlotDetails({
          ...timeSlotDetails,
          is_course_completed: 1
        });
      }
      
      // Also update in timeSlots array if needed
      setTimeSlots(prev => prev.map(slot => 
        slot.time_slot_id === Number(dynamicTimeSlotId) 
          ? { ...slot, is_course_completed: 1 }
          : slot
      ));
    } else {
      toast.error(data.message || "Failed to complete course");
    }
  } catch (error) {
    console.error("Error completing course:", error);
    toast.error("Error completing course. Please try again.");
  }
};



  // const handleAddAssignment = async (lessonId, assignmentId = null) => {
  //   if (assignmentId) {
  //     // If assignmentId is provided, assign it to the lesson
  //     try {
  //       const payload = {
  //         lesson_id: lessonId,
  //         assignment_id: assignmentId
  //       };

  //       const response = await fetch(SummaryApi.assignmentupdatelessonbyid.url, {
  //         method: SummaryApi.assignmentupdatelessonbyid.method,
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(payload),
  //       });

  //       const data = await response.json();

  //       if (data.status) {
  //         toast.success("Assignment added to lesson successfully!");

  //         // Refresh the lessons data to show the updated assignment
  //         setLessonsByCurriculum(prev => {
  //           const updated = { ...prev };
  //           Object.keys(updated).forEach(curriculumId => {
  //             updated[curriculumId] = updated[curriculumId].map(lesson =>
  //               lesson.lesson_id === lessonId
  //                 ? { ...lesson, assignment_id: assignmentId, is_submitted: 0 }
  //                 : lesson
  //             );
  //           });
  //           return updated;
  //         });

  //         setShowAssignmentModal(false);
  //         setSelectedAssignmentId("");
  //         setSelectedLessonId(null);
  //       } else {
  //         toast.error(data.message || "Failed to add assignment to lesson");
  //       }
  //     } catch (error) {
  //       console.error("Error adding assignment to lesson:", error);
  //       toast.error("Error adding assignment to lesson. Please try again.");
  //     }
  //   } else {
  //     // If no assignmentId, just open the modal to select one
  //     setSelectedLessonId(lessonId);

  //     try {
  //       const response = await fetch(SummaryApi.getAssignmentBycourseId.url, {
  //         method: SummaryApi.getAssignmentBycourseId.method,
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ course_id: Number(courseId) }),
  //       });
  //       const data = await response.json();
  //       if (data.status && Array.isArray(data.data)) {
  //         setAssignments(data.data);
  //       } else {
  //         setAssignments([]);

  //     setShowAssignmentModal(true);

  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch assignments:", error);
  //       setAssignments([]);
  //     }
  //   }
  // };

  // ... existing useEffects

  // 3. FETCH TOPICS BASED ON COURSE ID
  useEffect(() => {
    if (!courseId) return;

    const fetchTopics = async () => {
      try {
        const response = await fetch(SummaryApi.TopicByCourseId.url, {
          method: SummaryApi.TopicByCourseId.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ course_id: Number(courseId) }),
        });
        const data = await response.json();
        if (data.status) {
          setTopics(data.data || []);
        }
      } catch (error) {
        console.error("Error fetching topics:", error);
      }
    };

    fetchTopics();
  }, [courseId]);

  const handleTopicChange = async (e) => {
    const selectedCurriculumId = Number(e.target.value);

    // Update form: Set new Topic, CLEAR old Lesson
    setFormData((prev) => ({
      ...prev,
      curriculum_id: selectedCurriculumId,
      lesson_id: "", // Reset lesson to show "Select Lesson" placeholder
    }));

    // Clear old lessons list immediately
    setTopicLessons([]);

    if (selectedCurriculumId) {
      try {
        const response = await fetch(SummaryApi.LessonByTopicId.url, {
          method: SummaryApi.LessonByTopicId.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ curriculum_id: selectedCurriculumId }),
        });
        const data = await response.json();
        if (data.status) {
          setTopicLessons(data.data || []);
        }
      } catch (error) {
        console.error("Error fetching lessons:", error);
      }
    }
  };

  const handleAddAssignment = async (lessonId, assignmentId = null) => {
    if (assignmentId) {
      // If assignmentId is provided, assign it to the lesson
      try {
        const payload = {
          lesson_id: lessonId,
          assignment_id: assignmentId,
        };
        const response = await fetch(
          SummaryApi.assignmentupdatelessonbyid.url,
          {
            method: SummaryApi.assignmentupdatelessonbyid.method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          }
        );
        const data = await response.json();
        if (data.status) {
          toast.success("Assignment added to lesson successfully!");

          // Refresh the lessons data to show the updated assignment
          setLessonsByCurriculum((prev) => {
            const updated = { ...prev };
            Object.keys(updated).forEach((curriculumId) => {
              updated[curriculumId] = updated[curriculumId].map((lesson) =>
                lesson.lesson_id === lessonId
                  ? { ...lesson, assignment_id: assignmentId, is_submitted: 0 }
                  : lesson
              );
            });
            return updated;
          });
          setShowAssignmentModal(false);
          setSelectedAssignmentId("");
          setSelectedLessonId(null);
        } else {
          toast.error(data.message || "Failed to add assignment to lesson");
        }
      } catch (error) {
        console.error("Error adding assignment to lesson:", error);
        toast.error("Error adding assignment to lesson. Please try again.");
      }
    } else {
      // If no assignmentId, just open the modal to select one
      setSelectedLessonId(lessonId);
      try {
        const response = await fetch(SummaryApi.getAssignmentBycourseId.url, {
          method: SummaryApi.getAssignmentBycourseId.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ course_id: Number(courseId) }),
        });
        const data = await response.json();
        if (data.status && Array.isArray(data.data)) {
          setAssignments(data.data);
        } else {
          setAssignments([]);
        }
        setShowAssignmentModal(true);
      } catch (error) {
        console.error("Failed to fetch assignments:", error);
        setAssignments([]);
        setShowAssignmentModal(true);
      }
    }
  };

  const handleViewAssignment = async (assignmentId) => {
    try {
      // Fetch assignment basic details
      const assignmentResponse = await fetch(
        SummaryApi.assignment_by_id_retrieve_by_id.url,
        {
          method: SummaryApi.assignment_by_id_retrieve_by_id.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ assignment_id: assignmentId }),
        }
      );
      const assignmentData = await assignmentResponse.json();

      if (assignmentData.status && assignmentData.data) {
        const assignment = assignmentData.data;

        // Fetch questions for this assignment
        const questionsResponse = await fetch(
          SummaryApi.questionary_form_by_assignment.url,
          {
            method: SummaryApi.questionary_form_by_assignment.method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ assignment_id: assignmentId }),
          }
        );
        const questionsData = await questionsResponse.json();

        // Combine assignment with questions
        const assignmentWithQuestions = {
          ...assignment,
          questions: questionsData.status ? questionsData.data || [] : [],
        };

        setViewedAssignment(assignmentWithQuestions);
        setShowAssignmentDetails(true);
      } else {
        toast.error("Assignment not found");
      }
    } catch (err) {
      console.error("Failed to fetch assignment:", err);
      toast.error("Error fetching assignment details");
    }
  };





// Function to fetch assignment scores for a specific student
const fetchAssignmentScores = async (student) => {
  if (!student || !student.student_id) return;
  
  setLoadingScores(true);
  setSelectedStudentForScores(student);
  
  try {
    // Fetch all assignments first
    const assignmentsResponse = await fetch(SummaryApi.assignmentsallbasedontimeslotbyid.url, {
      method: SummaryApi.assignmentsallbasedontimeslotbyid.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        course_id: Number(courseId),
        time_slot_id: Number(dynamicTimeSlotId),
        instructor_id: instructorId
      }),
    });
    
    const assignmentsData = await assignmentsResponse.json();
    
    if (assignmentsData.status) {
      const allAssignmentsList = assignmentsData.data || [];
      setAllAssignments(allAssignmentsList);
      
      // Fetch student results
      const resultsResponse = await fetch(SummaryApi.assignmentsstudentstatusallbasedontimeslotbyid.url, {
        method: SummaryApi.assignmentsstudentstatusallbasedontimeslotbyid.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          student_id: student.student_id,
          course_id: Number(courseId),
          time_slot_id: Number(dynamicTimeSlotId),
          instructor_id: instructorId
        }),
      });
      
      const resultsData = await resultsResponse.json();
      const studentResults = resultsData.status ? resultsData.data || [] : [];
      
// Update this part in the fetchAssignmentScores function
const scoresWithAssignments = allAssignmentsList.map(assignment => {
  const result = studentResults.find(res => res.assignment_id === assignment.assignment_id);
  
  if (result) {
    return {
      assignment_id: assignment.assignment_id,
      assignment_name: assignment.assignment_name,
      total_marks: result.total_marks || 0,
      pass_marks: result.pass_marks || 0,
      has_result: true,
      qualify_marks: assignment.qualify_marks || 0,
      result_is_active: result.result_is_active,
      result_created_date: result.result_created_date // Add this line
    };
  } else {
    return {
      assignment_id: assignment.assignment_id,
      assignment_name: assignment.assignment_name,
      total_marks: null,
      pass_marks: null,
      has_result: false,
      qualify_marks: assignment.qualify_marks || 0,
      result_is_active: null,
      result_created_date: null // Add this line
    };
  }
});
      
      setAssignmentScores(scoresWithAssignments);
    } else {
      setAssignmentScores([]);
      toast.error("Failed to fetch assignments");
    }
  } catch (error) {
    console.error("Error fetching assignment scores:", error);
    toast.error("Error fetching assignment scores");
    setAssignmentScores([]);
  } finally {
    setLoadingScores(false);
  }
};


// Function to close assignment score modal
const closeAssignmentScoreModal = () => {
  setShowAssignmentScoreModal(false);
  setSelectedStudentForScores(null);
  setAssignmentScores([]);
  setAllAssignments([]);
};











  const handleCloseLesson = async (lesson) => {
    if (!dynamicTimeSlotId || isNaN(Number(dynamicTimeSlotId))) {
      Swal.fire({
        icon: "error",
        title: "Invalid Time Slot",
        text: "Time slot ID is missing or invalid. Please try again.",
      });
      return;
    }
    if (lesson.is_closed) {
      Swal.fire({
        icon: "info",
        title: "Lesson Already Closed",
        text: `The lesson "${lesson.lesson_name}" is already marked as closed.`,
      });
      return;
    }
    const lessons = lessonsByCurriculum[lesson.curriculum_id] || [];
    const lessonIndex = lessons.findIndex(
      (l) => l.lesson_id === lesson.lesson_id
    );
    if (lessonIndex > 0) {
      const previousLesson = lessons[lessonIndex - 1];
      if (previousLesson && !previousLesson.is_closed) {
        Swal.fire({
          icon: "warning",
          title: "Cannot Close Lesson",
          text: `Please complete the previous lesson: "${previousLesson.lesson_name}" before closing this one.`,
        });
        return;
      }
    }
    const currentCurriculumIndex = curriculum.findIndex(
      (c) => c.curriculum_id === lesson.curriculum_id
    );
    if (currentCurriculumIndex > 0) {
      const previousCurriculumId =
        curriculum[currentCurriculumIndex - 1].curriculum_id;
      const previousCurriculumLessons =
        lessonsByCurriculum[previousCurriculumId] || [];
      const isPreviousCurriculumCompleted = previousCurriculumLessons.every(
        (l) => l.is_closed === 1
      );
      if (!isPreviousCurriculumCompleted) {
        const previousTopicName =
          curriculum[currentCurriculumIndex - 1].topic_name;
        Swal.fire({
          icon: "warning",
          title: "Cannot Close Lesson",
          text: `Please complete all lessons in the previous topic "${previousTopicName}" before closing lessons in this topic.`,
        });
        return;
      }
    }
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: `Do you really want to close the section "${lesson.lesson_name}"? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, close it!",
    });
    if (!confirmed.isConfirmed) return;
    const payload = {
      instructor_id: instructorId,
      curriculum_id: lesson.curriculum_id,
      lesson_id: lesson.lesson_id,
      time_slot_id: Number(dynamicTimeSlotId),
      course_id: lesson.course_id,
      batch_name: dynamicBatchName || "default_batch",
      is_closed: 1,
      closed_date: new Date().toISOString().split("T")[0],
    };
    try {
      const lessonCloseResponse = await fetch(SummaryApi.LessonClose.url, {
        method: SummaryApi.LessonClose.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const lessonCloseData = await lessonCloseResponse.json();
      if (lessonCloseData.status) {
        Swal.fire({
          icon: "success",
          title: "Lesson Closed Successfully",
          text: `Lesson "${lesson.lesson_name}" has been marked as closed.`,
        });
        const newClosedLesson = {
          lesson_closed_id:
            lessonCloseData.data?.lesson_closed_id || Date.now(),
          ...payload,
        };
        setClosedLessons((prev) => [...prev, newClosedLesson]);
        setLessonsByCurriculum((prev) => {
          const updated = { ...prev };
          if (updated[lesson.curriculum_id]) {
            updated[lesson.curriculum_id] = updated[lesson.curriculum_id].map(
              (l) =>
                l.lesson_id === lesson.lesson_id ? { ...l, is_closed: 1 } : l
            );
          }
          return updated;
        });
        const updatedLessons = lessons.map((l) =>
          l.lesson_id === lesson.lesson_id ? { ...l, is_closed: 1 } : l
        );
        const allLessonsClosed = updatedLessons.every((l) => l.is_closed === 1);
        if (allLessonsClosed) {
          const topicPayload = {
            instructor_id: instructorId,
            curriculum_id: lesson.curriculum_id,
            course_id: lesson.course_id,
            time_slot_id: Number(dynamicTimeSlotId),
            batch_name: dynamicBatchName || "default_batch",
            is_closed: 1,
            closed_date: new Date().toISOString().split("T")[0],
          };
          try {
            const topicCloseResponse = await fetch(
              SummaryApi.createtopicclosed.url,
              {
                method: SummaryApi.createtopicclosed.method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(topicPayload),
              }
            );
            const topicCloseData = await topicCloseResponse.json();
            if (topicCloseData.status) {
              Swal.fire({
                icon: "success",
                title: "Topic Closed Successfully",
                text: `Topic for curriculum ${lesson.curriculum_id} has been marked as closed.`,
              });
              setClosedTopics((prev) => [
                ...prev,
                topicCloseData.data || topicPayload,
              ]);
            } else {
              Swal.fire({
                icon: "error",
                title: "Failed to Close Topic",
                text: topicCloseData.message || "Please try again later.",
              });
            }
          } catch (topicError) {
            console.error("Error closing topic:", topicError);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Failed to close topic. Please try again.",
            });
          }
        }
      } else {
        if (
          lessonCloseData.message &&
          lessonCloseData.message.includes("already exists")
        ) {
          Swal.fire({
            icon: "info",
            title: "Lesson Already Closed",
            text: "This lesson was already closed in the database.",
          });
          setLessonsByCurriculum((prev) => {
            const updated = { ...prev };
            if (updated[lesson.curriculum_id]) {
              updated[lesson.curriculum_id] = updated[lesson.curriculum_id].map(
                (l) =>
                  l.lesson_id === lesson.lesson_id ? { ...l, is_closed: 1 } : l
              );
            }
            return updated;
          });
          const newClosedLesson = {
            lesson_closed_id: Date.now(),
            instructor_id: instructorId,
            curriculum_id: lesson.curriculum_id,
            lesson_id: lesson.lesson_id,
            time_slot_id: Number(dynamicTimeSlotId),
            course_id: lesson.course_id,
            is_closed: 1,
            closed_date: new Date().toISOString().split("T")[0],
          };
          setClosedLessons((prev) => {
            if (
              !prev.some(
                (cl) =>
                  cl.lesson_id === lesson.lesson_id &&
                  cl.time_slot_id === Number(dynamicTimeSlotId)
              )
            ) {
              return [...prev, newClosedLesson];
            }
            return prev;
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed to Close Lesson",
            text: lessonCloseData.message || "Please try again later.",
          });
        }
      }
    } catch (err) {
      console.error("Error closing lesson:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while closing the lesson.",
      });
    }
  };

  const handleSelectStudent = (studentProjectId) => {
    setSelectedStudents((prev) => {
      if (prev.includes(studentProjectId)) {
        return prev.filter((id) => id !== studentProjectId);
      } else {
        return [...prev, studentProjectId];
      }
    });
  };

  const handleSelectAll = () => {
    const eligibleStudents = enrolledStudents
      .filter((student) => student.project_is_active && student.is_review !== 1)
      .map((student) => student.student_project_id);

    if (
      selectedStudents.length === eligibleStudents.length &&
      eligibleStudents.length > 0
    ) {
      // All eligible are selected → deselect all
      setSelectedStudents([]);
    } else {
      // Select all eligible
      setSelectedStudents(eligibleStudents);
    }
  };

  // const handleSaveProject = async (e) => {
  //   e.preventDefault();
  //   const formData = new FormData(e.target);
  //   const uploadFormData = new FormData();

  //   if (imageFile) {
  //     uploadFormData.append("project_image", imageFile);
  //   }

  //   uploadFormData.append("project_id", project?.project_id || "");
  //   uploadFormData.append("project_name", formData.get("project_name"));
  //   uploadFormData.append("project_title", formData.get("project_title"));
  //   uploadFormData.append("subtitle", formData.get("subtitle"));
  //   uploadFormData.append("description", formData.get("description"));
  //   uploadFormData.append("course_id", Number(courseId));
  //   uploadFormData.append("time_slot_id", Number(dynamicTimeSlotId));
  //   uploadFormData.append("instructor_id", instructorId);
  //   uploadFormData.append("slot_id", Number(dynamicTimeSlotId));
  //   uploadFormData.append("submission_date", formData.get("submission_date"));
  //   uploadFormData.append("is_active", projectActive ? 1 : 0); // Use React state here
  //   uploadFormData.append("created_date", new Date().toISOString().split("T")[0]);

  //   const url = project?.project_id
  //     ? SummaryApi.instructorupdateproject.url
  //     : SummaryApi.instructorcreateproject.url;
  //   const method = project?.project_id
  //     ? SummaryApi.instructorupdateproject.method
  //     : SummaryApi.instructorcreateproject.method;

  //   try {
  //     const response = await fetch(url, {
  //       method: method,
  //       body: uploadFormData,
  //     });
  //     const data = await response.json();

  //     if (data.status) {
  //       toast.success(
  //         project?.project_id ? "Project updated successfully!" : "Project created successfully!"
  //       );

  //       // Refresh project data
  //       fetch(SummaryApi.instructorretrievebasedontimeslotandcourseid.url, {
  //         method: SummaryApi.instructorretrievebasedontimeslotandcourseid.method,
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           course_id: Number(courseId),
  //           time_slot_id: Number(dynamicTimeSlotId),
  //         }),
  //       })
  //         .then((res) => res.json())
  //         .then((refreshData) => {
  //           if (refreshData.status && refreshData.data && refreshData.data.length > 0) {
  //             const updatedProject = refreshData.data[0];
  //             setProject(updatedProject);
  //             setProjectActive(updatedProject.is_active === 1); // Update state
  //             if (updatedProject.project_image) {
  //               setPreviewImage(formatImageUrl(updatedProject.project_image));
  //             } else {
  //               setPreviewImage(null);
  //             }
  //           }
  //         });

  //       // Reset image file state
  //       setImageFile(null);
  //     } else {
  //       toast.error(data.message || "Please try again.");
  //     }
  //   } catch (err) {
  //     console.error("Error saving project:", err);
  //     toast.error("Something went wrong while saving the project.");
  //   }
  // };
  const handleSaveProject = async (e) => {
    e.preventDefault();
    setProjectLoading(true); // Start loading

    const formData = new FormData(e.target);
    const uploadFormData = new FormData();

    if (imageFile) {
      uploadFormData.append("project_image", imageFile);
    }

    uploadFormData.append("project_id", project?.project_id || "");
    uploadFormData.append("project_name", formData.get("project_name"));
    uploadFormData.append("project_title", formData.get("project_title"));
    uploadFormData.append("subtitle", formData.get("subtitle"));
    uploadFormData.append("description", formData.get("description"));
    uploadFormData.append("course_id", Number(courseId));
    uploadFormData.append("time_slot_id", Number(dynamicTimeSlotId));
    uploadFormData.append("instructor_id", instructorId);
    uploadFormData.append("slot_id", Number(dynamicTimeSlotId));
    uploadFormData.append("submission_date", formData.get("submission_date"));
    uploadFormData.append("is_active", projectActive ? 1 : 0);
    uploadFormData.append(
      "created_date",
      new Date().toISOString().split("T")[0]
    );

    const url = project?.project_id
      ? SummaryApi.instructorupdateproject.url
      : SummaryApi.instructorcreateproject.url;
    const method = project?.project_id
      ? SummaryApi.instructorupdateproject.method
      : SummaryApi.instructorcreateproject.method;

    try {
      const response = await fetch(url, {
        method: method,
        body: uploadFormData,
      });
      const data = await response.json();

      if (data.status) {
        toast.success(
          project?.project_id
            ? "Project updated successfully!"
            : "Project created successfully!"
        );

        // Refresh project data
        fetch(SummaryApi.instructorretrievebasedontimeslotandcourseid.url, {
          method:
            SummaryApi.instructorretrievebasedontimeslotandcourseid.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            course_id: Number(courseId),
            time_slot_id: Number(dynamicTimeSlotId),
          }),
        })
          .then((res) => res.json())
          .then((refreshData) => {
            if (
              refreshData.status &&
              refreshData.data &&
              refreshData.data.length > 0
            ) {
              const updatedProject = refreshData.data[0];
              setProject(updatedProject);
              setProjectActive(updatedProject.is_active === 1);
              if (updatedProject.project_image) {
                setPreviewImage(formatImageUrl(updatedProject.project_image));
              } else {
                setPreviewImage(null);
              }
            }
          });

        // Reset image file state and close modal
        setImageFile(null);
        setShowProjectModal(false);
      } else {
        toast.error(data.message || "Please try again.");
      }
    } catch (err) {
      console.error("Error saving project:", err);
      toast.error("Something went wrong while saving the project.");
    } finally {
      setProjectLoading(false); // End loading regardless of success/error
    }
  };
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProjectModalOpen = () => {
    setShowProjectModal(true);
    setImageFile(null);
    if (project?.project_image) {
      setPreviewImage(formatImageUrl(project.project_image));
    } else {
      setPreviewImage(null);
    }
  };

  const generateCertificateEmail = async ({
    student_name,
    course_title,
    start_date,
    end_date,
  }) => {
    // Convert images to base64 data URLs
    const skillaraLogoBase64 = await convertImageToBase64(skillaraLogo);
    const ribbonBase64 = await convertImageToBase64(ribbonImage);
    const googleLogoBase64 = await convertImageToBase64(googleLogo);
    const microsoftLogoBase64 = await convertImageToBase64(microsoftLogo);
    const greatBadgeBase64 = await convertImageToBase64(greatBadge);
    const skillaraBgBase64 = await convertImageToBase64(skillaraBg);
    const awsBase64 = await convertImageToBase64(awsPath);

    return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Skillara Certificate</title>
    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&family=Great+Vibes&display=swap" rel="stylesheet">
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        body {
            background: #f5f5f5;
            margin: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            font-family: "Poppins", sans-serif;
        }
        .certificate {
            width: 1200px;
            height: 650px;
            background: white;
            position: relative;
            text-align: center;
            font-family: 'Poppins', sans-serif;
            overflow: hidden;
            background-image: url("${skillaraBgBase64}");
            background-size: cover;
            background-position: center;
            margin: 0;
            padding: 0;
        }

        /* PDF-specific styles to prevent zooming and cutoff */
        .certificate-pdf {
            width: 1200px !important;
            height: 650px !important;
            transform: none !important;
            zoom: 1 !important;
        }
        
        .certificate-pdf * {
            max-width: none !important;
            transform: none !important;
        }

        /* Top Right Logo */
        .logo {
            position: absolute;
            top: 40px;
            right: 40px;
            width: 140px;
            height: auto;
        }

        /* Title */
        .title {
            font-size: 40px;
            font-weight: 700;
            color: #113A72;
            letter-spacing: 3px;
            margin-top: 40px;
            margin-bottom: 10px;
        }

        /* Ribbon Wrapper */
        .ribbon-wrapper {
            position: relative;
            display: inline-block;
            width: 400px;
            margin: 0 auto;
        }

        .ribbon-img {
            width: 66%;
            display: block;
            margin: 0 auto;
        }

        .ribbon-text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: "Poppins", sans-serif;
            font-size: 12px;
            font-weight: bold;
            color: white;
            text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
            letter-spacing: 1px;
            width: 100%;
            text-align: center;
        }

        /* Text Above Name */
        .presented {
            margin-top: 15px;
            font-size: 16px;
            letter-spacing: 1px;
            color: #333;
        }

        /* Student Name */
        .username {
            font-family: "Great Vibes", cursive !important;
            font-size: 60px;
            margin: 8px 0;
            color: #6E6E6E;
            border-bottom: 2px solid #CFA142;
            display: inline-block;
            padding-bottom: 5px;
        }

        /* Under Name Text */
        .course-subtitle {
            font-size: 14px;
            margin-top: 10px;
            color: #444;
            font-style: italic;
        }

        /* Course Name */
        .course-name {
            font-size: 23px;
            margin-top: -3px;
            color: #0B0C0C;
            font-weight: 700;
            letter-spacing: 1px;
        }

        /* Date Row */
        .date-row {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin-top: 30px;
            font-size: 16px;
        }

        .date-row span {
            font-weight: 400;
            margin-right: 6px;
        }

        .date-row strong {
            font-weight: 600;
            border-bottom: 2px solid #D5B35F;
            padding: 2px 4px;
        }

        /* Footer Message */
        .message {
            margin-top: 31px;
            font-style: italic;
            letter-spacing: 3px;
            font-size: 16px;
            color: #333;
        }

        /* Bottom Row */
        .bottom-row {
            margin-top: 40px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding: 0 80px;
            width: calc(100% - 160px);
        }

        .left-section {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 10px;
        }

        .center-section {
            flex: 1;
            display: flex;
            justify-content: center;
        }

        .right-section {
            flex: 1;
            display: flex;
            justify-content: flex-end;
        }

        .signature-block {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .signature-text {
            font-family: "Great Vibes", cursive;
            font-size: 40px;
            font-weight: 400;
            color: #113A72;
            margin-bottom: 5px;
        }

        .sig-line {
            width: 200px;
            height: 3px;
            background: #D5B35F;
            margin-bottom: 5px;
        }

        .sign {
            font-family: "Great Vibes", cursive;
            font-size: 27px;
            font-weight: 300;
            color: #113A72;
        }

        .badge {
            width: 85px;
        }

        /* Partners Section */
        .partners-section {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
        }

        .partners-label {
            font-size: 16px;
            font-weight: 500;
            color: #113A72;
            letter-spacing: 1px;
        }

        .partners-icons {
            display: flex;
            gap: 15px;
            align-items: center;
        }

        .partner-logo {
            height: 30px;
            width: auto;
            transition: transform 0.3s ease;
            object-fit: contain;
        }

        .partner-logo:hover {
            transform: scale(1.1);
        }

        .google-logo {
            height: 28px;
        }

        .aws-logo {
            height: 28px;
        }

        .microsoft-logo {
            height: 24px;
        }

        /* Responsive CSS */
        @media (max-width: 1024px) {
            .certificate {
                width: 90%;
                height: auto;
                padding: 30px 15px;
            }
            .title { font-size: 30px; }
            .username { font-size: 50px; }
            .course-name { font-size: 20px; }
            .signature-text { font-size: 40px; }
            .badge { width: 70px; }
            .sig-line { width: 150px; }
            .date-row { gap: 10px; flex-wrap: wrap; }
            .message { font-size: 14px; letter-spacing: 2px; }
            .bottom-row { padding: 0 40px; }
        }

        @media (max-width: 768px) {
            .title { font-size: 32px; }
            .username { font-size: 38px; }
            .course-name { font-size: 18px; }
            .signature-text { font-size: 32px; }
            .badge { width: 60px; }
            .sig-line { width: 120px; }
            .ribbon-text { font-size: 14px; }
            .bottom-row {
                padding: 0 20px;
                flex-wrap: wrap;
                gap: 20px;
            }
            .left-section, .center-section, .right-section {
                justify-content: center;
                align-items: center;
                flex: none;
                width: 100%;
            }
            .partners-section {
                align-items: center;
                text-align: center;
            }
        }

        @media (max-width: 480px) {
            .title { font-size: 32px; }
            .username { font-size: 28px; }
            .course-name { font-size: 16px; }
            .signature-text { font-size: 24px; }
            .badge { width: 50px; }
            .sig-line { width: 100px; }
            .bottom-row {
                padding: 0 10px;
                flex-direction: column;
                gap: 15px;
            }
            .date-row { flex-direction: column; gap: 5px; }
            .message { font-size: 12px; letter-spacing: 1px; }
            .logo { width: 100px; top: 20px; right: 15px; }
            .partners-label { font-size: 16px; }
            .partners-icons { gap: 8px; }
        }

        /* PDF Generation Overrides - Critical for preventing zoom/cutoff */
        @media print {
            .certificate {
                width: 1200px !important;
                height: 650px !important;
                transform: none !important;
                zoom: 1 !important;
            }
            .certificate * {
                max-width: none !important;
                transform: none !important;
            }
        }
        
        .pdf-container {
            width: 1200px !important;
            height: 650px !important;
            position: relative !important;
        }
    </style>
</head>

<body>
<div class="certificate pdf-container">
    <!-- Top Right Logo -->
    <img src="${skillaraLogoBase64}" class="logo" alt="Skillara Logo">

    <h1 class="title">CERTIFICATE</h1>

    <div class="ribbon-wrapper">
        <img src="${ribbonBase64}" class="ribbon-img" alt="Ribbon">
        <div class="ribbon-text">OF APPRECIATION</div>
    </div>

    <p class="presented">THIS CERTIFICATE IS PROUDLY PRESENTED TO</p>

    <h2 class="username">${student_name}</h2>

    <p class="course-subtitle">On Completion of the Course</p>

    <h3 class="course-name">${course_title}</h3>

    <div class="date-row">
        <div>
            <span>From</span>
            <strong>${start_date}</strong>
        </div>
        <div>
            <span>To</span>
            <strong>${end_date}</strong>
        </div>
    </div>

    <p class="message">
        From Skillara we wish you all the best
    </p>

    <div class="bottom-row">
        <!-- Left section - Partners -->
        <div class="left-section">
            <div class="partners-section">
                <div class="partners-label">Our Partners</div>
                <div class="partners-icons">
                    <img src="${googleLogoBase64}" alt="Google" class="partner-logo google-logo">
                    <img src="${awsBase64}" alt="AWS" class="partner-logo aws-logo">
                    <img src="${microsoftLogoBase64}" alt="Microsoft" class="partner-logo microsoft-logo">
                </div>
            </div>
        </div>

        <!-- Center section - Badge -->
        <div class="center-section">
            <div class="badge-block">
                <img src="${greatBadgeBase64}" class="badge" alt="Great Badge">
            </div>
        </div>

        <!-- Right section - Signature -->
        <div class="right-section">
            <div class="signature-block">
                <div class="signature-text">Signature</div>
                <div class="sig-line"></div>
                <div class="sign">P.Hrithik</div>
            </div>
        </div>
    </div>
</div>
</body>
</html>
  `;
  };

  const handleModalBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      setShowProjectModal(false);
    }
  };

  // Assignment form handlers
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleQuestionChange = (e) => {
    const { name, value, type, checked } = e.target;
    setQuestionFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleToggle = () => {
    setFormData((prev) => ({
      ...prev,
      is_active: !prev.is_active,
    }));
  };

  const handleQuestionToggle = () => {
    setQuestionFormData((prev) => ({
      ...prev,
      is_active: !prev.is_active,
    }));
  };

  const handleEdit = async (assignmentId) => {
    try {
      const res = await fetch(SummaryApi.assignment_by_id_retrieve_by_id.url, {
        method: SummaryApi.assignment_by_id_retrieve_by_id.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ assignment_id: assignmentId }),
      });
      const data = await res.json();

      if (data.status) {
        const assignment = data.data;

        // 1. EXTRACT IDs FROM THE "lessons" ARRAY
        // The API returns an array, we take the first item to get the current link
        let existingCurriculumId = "";
        let existingLessonId = "";

        if (assignment.lessons && assignment.lessons.length > 0) {
          existingCurriculumId = Number(assignment.lessons[0].curriculum_id);
          existingLessonId = Number(assignment.lessons[0].lesson_id);
        }

        // 2. FETCH LESSONS FOR THE SPECIFIC TOPIC
        // We must fetch the lessons list for this topic so the dropdown has options
        if (existingCurriculumId) {
          try {
            const lessonRes = await fetch(SummaryApi.LessonByTopicId.url, {
              method: SummaryApi.LessonByTopicId.method,
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                curriculum_id: existingCurriculumId,
              }),
            });
            const lessonData = await lessonRes.json();
            if (lessonData.status) {
              setTopicLessons(lessonData.data || []);
            } else {
              setTopicLessons([]);
            }
          } catch (lessonErr) {
            console.error("Error fetching lessons for edit:", lessonErr);
            setTopicLessons([]);
          }
        } else {
          // If no topic is linked, clear the lessons list
          setTopicLessons([]);
        }

        // 3. SET FORM DATA
        setFormData({
          instructor_id: instructorId || "",
          course_id: courseId || "",
          time_slot_id: dynamicTimeSlotId || "",
          assignment_name: assignment.assignment_name || "",
          number_of_questions: assignment.number_of_questions || "",
          is_active:
            assignment.is_active === 1 || assignment.is_active === true,
          assignment_id: assignment.assignment_id || "",

          // Set the extracted IDs to pre-fill dropdowns
          curriculum_id: existingCurriculumId,
          lesson_id: existingLessonId,
        });

        setIsEditing(true);
        // Scroll to the form
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        toast.error(data.message || "Failed to fetch assignment details");
      }
    } catch (err) {
      console.error("Error fetching assignment:", err);
      toast.error("Error fetching assignment details. Please try again.");
    }
  };

  const handleAddQuestion = (assignment) => {
    setQuestionFormData({
      question_id: "",
      assignment_id: assignment.assignment_id,
      course_id: courseId,
      question_name: "",
      option_a: "",
      option_b: "",
      option_c: "",
      option_d: "",
      correct_answer: "",
      marks: "",
      is_active: true,
    });
    setCurrentAssignment(assignment);
    setIsQuestionEditing(false);
    setIsQuestionsListModalOpen(true);
  };

  const handleEditSpecificQuestion = async (questionId, assignment) => {
    setIsQuestionEditing(true);
    setCurrentAssignment(assignment);
    setIsQuestionsListModalOpen(true);

    try {
      const res = await fetch(SummaryApi.questionary_by_id.url, {
        method: SummaryApi.questionary_by_id.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ question_id: questionId }),
      });
      const data = await res.json();
      if (data.status && data.data) {
        const q = data.data;
        setQuestionFormData({
          question_id: q.question_id || "",
          assignment_id: assignment.assignment_id, // ← CRITICAL: KEEP THIS
          course_id: courseId,
          question_name: q.question_name || "",
          option_a: q.option_a || "",
          option_b: q.option_b || "",
          option_c: q.option_c || "",
          option_d: q.option_d || "",
          correct_answer: q.correct_answer || "",
          marks: q.marks || "",
          is_active: q.is_active ?? true,
        });
      } else {
        toast.error(data.message || "Failed to fetch question details");
      }
    } catch (err) {
      console.error("Error fetching question by ID:", err);
      toast.error("Error fetching question details.");
    }
  };

const refreshAssignmentsAndQuestions = async () => {
  try {
    // Fetch assignments for this specific instructor AND course
    const resAssignments = await fetch(SummaryApi.assignmentByCourseId.url, {
      method: SummaryApi.assignmentByCourseId.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        instructor_id: instructorId,
        course_id: Number(courseId), // Make sure to include course_id
      }),
    });
    const assignmentsData = await resAssignments.json();
    if (assignmentsData.status) {
      setAssignments(assignmentsData.data || []);
    } else {
      toast.error(assignmentsData.message || "Failed to refresh assignments");
    }
  } catch (err) {
    console.error("Error refreshing assignments:", err);
    toast.error("Error refreshing assignments. Please try again.");
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.course_id ||
      !formData.assignment_name ||
      !formData.number_of_questions
    ) {
      toast.warning("Please fill all required fields");
      return;
    }

    setLoading(true);

    try {
      // 2. Determine API: Create or Update Assignment
      const api = isEditing
        ? SummaryApi.updateassignment_instructor
        : SummaryApi.CreateAssignment;

      // 3. Call Assignment API
      const res = await fetch(api.url, {
        method: api.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          time_slot_id: Number(dynamicTimeSlotId),
        }),
      });

      const data = await res.json();

      // *** DEBUG LOG 1: Check the full API response ***
      console.log("1. Create/Update Assignment API Response:", data);

      if (data.status) {
        // -----------------------------------------------------------
        // STEP 4: EXTRACT THE ASSIGNMENT ID ROBUSTLY
        // -----------------------------------------------------------
        let savedAssignmentId = null;

        if (isEditing) {
          savedAssignmentId = formData.assignment_id;
        } else {
          // Attempt to find the ID in the response structure
          // Check: data.data.assignment_id OR data.assignment_id OR plain data.data
          savedAssignmentId =
            data.data?.assignment_id || data.assignment_id || data.data;
        }

        // *** DEBUG LOG 2: Check the IDs before hitting the second API ***
        console.log("2. Extracted Assignment ID:", savedAssignmentId);
        console.log("3. Selected Lesson ID from Form:", formData.lesson_id);

        // -----------------------------------------------------------
        // STEP 5: HIT THE LESSON UPDATE API
        // -----------------------------------------------------------
        if (formData.lesson_id && savedAssignmentId) {
          try {
            const updateLessonPayload = {
              assignment_id: Number(savedAssignmentId),
              lesson_id: Number(formData.lesson_id),
            };

            // *** DEBUG LOG 3: Payload for second API ***
            console.log(
              "4. Hitting Lesson Update API with Payload:",
              updateLessonPayload
            );

            const linkResponse = await fetch(
              SummaryApi.assignmentupdatelessonbyid.url,
              {
                method: SummaryApi.assignmentupdatelessonbyid.method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateLessonPayload),
              }
            );

            const linkData = await linkResponse.json();
            console.log("5. Lesson Update API Response:", linkData);

            if (linkData.status) {
              // -----------------------------------------------------------
              // STEP 6: UPDATE LOCAL STATE
              // -----------------------------------------------------------
              setLessonsByCurriculum((prev) => {
                const updated = { ...prev };
                Object.keys(updated).forEach((curriculumId) => {
                  updated[curriculumId] = updated[curriculumId].map(
                    (lesson) => {
                      if (lesson.lesson_id === Number(formData.lesson_id)) {
                        return {
                          ...lesson,
                          assignment_id: Number(savedAssignmentId),
                          is_submitted: 0,
                        };
                      }
                      return lesson;
                    }
                  );
                });
                return updated;
              });

              toast.success(
                "Assignment created and linked to lesson successfully!"
              );
            } else {
              console.warn("Lesson linking failed:", linkData.message);
              toast.warning(
                "Assignment created, but failed to link to lesson."
              );
            }
          } catch (linkError) {
            console.error("Error linking assignment:", linkError);
          }
        } else {
          console.log(
            "Skipping Lesson Update: Either Lesson ID or Assignment ID is missing."
          );
          toast.success(
            isEditing ? "Assignment updated!" : "Assignment created!"
          );
        }

        // 7. Cleanup / Reset Form
        setFormData({
          instructor_id: instructorId || "",
          course_id: courseId || "",
          time_slot_id: dynamicTimeSlotId || "",
          assignment_name: "",
          number_of_questions: "",
          is_active: true,
          assignment_id: "",
          curriculum_id: "",
          lesson_id: "",
        });

        setTopicLessons([]);
        setIsEditing(false);
        refreshAssignmentsAndQuestions();
      } else {
        toast.error(data.message || "Failed to save assignment");
      }
    } catch (err) {
      console.error("Error in handleSubmit:", err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

const handleQuestionSubmit = async (e) => {
  e.preventDefault();
  if (
    !questionFormData.question_name ||
    !questionFormData.option_a ||
    !questionFormData.option_b ||
    !questionFormData.option_c ||
    !questionFormData.option_d ||
    !questionFormData.correct_answer ||
    !questionFormData.marks ||
    !questionFormData.assignment_id
  ) {
    toast.warning("Please fill all required fields");
    return;
  }
  setLoading(true);
  try {
    const api = isQuestionEditing
      ? SummaryApi.updatequestionaryform
      : SummaryApi.createquestionaryform;
    const res = await fetch(api.url, {
      method: api.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(questionFormData),
    });
    const data = await res.json();
    if (data.status) {
      toast.success(
        isQuestionEditing
          ? "Question updated successfully!"
          : "Question created successfully!"
      );

      // CRITICAL: Update questionsMap immediately
      const assignmentId = questionFormData.assignment_id;
      
      if (isQuestionEditing) {
        // Update existing question in questionsMap
        setQuestionsMap(prev => {
          const updatedMap = { ...prev };
          if (updatedMap[assignmentId]) {
            updatedMap[assignmentId] = updatedMap[assignmentId].map(q => 
              q.question_id === questionFormData.question_id 
                ? { 
                    ...q, 
                    question_name: questionFormData.question_name,
                    option_a: questionFormData.option_a,
                    option_b: questionFormData.option_b,
                    option_c: questionFormData.option_c,
                    option_d: questionFormData.option_d,
                    correct_answer: questionFormData.correct_answer,
                    marks: questionFormData.marks,
                    is_active: questionFormData.is_active
                  } 
                : q
            );
          }
          return updatedMap;
        });
      } else {
        // Add new question to questionsMap
        setQuestionsMap(prev => {
          const updatedMap = { ...prev };
          const newQuestion = {
            question_id: data.data?.question_id || Date.now(),
            assignment_id: assignmentId,
            course_id: questionFormData.course_id,
            question_name: questionFormData.question_name,
            option_a: questionFormData.option_a,
            option_b: questionFormData.option_b,
            option_c: questionFormData.option_c,
            option_d: questionFormData.option_d,
            correct_answer: questionFormData.correct_answer,
            marks: questionFormData.marks,
            is_active: questionFormData.is_active
          };
          
          if (!updatedMap[assignmentId]) {
            updatedMap[assignmentId] = [];
          }
          updatedMap[assignmentId] = [...updatedMap[assignmentId], newQuestion];
          return updatedMap;
        });
      }

      // Reset the form after BOTH create AND update
      setQuestionFormData({
        question_id: "",
        assignment_id: currentAssignment.assignment_id,
        course_id: courseId,
        question_name: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        correct_answer: "",
        marks: "",
        is_active: true,
      });
      
      setIsQuestionEditing(false);
      
      // Also refresh assignments to update the count in the main table
      await refreshAssignmentsAndQuestions(); // Wait for refresh
      
      // Do NOT close the modal automatically - let user decide
    } else {
      toast.error(data.message || "Operation failed");
    }
  } catch (err) {
    console.error("Error:", err);
    toast.error("Something went wrong");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (currentAssignment && isQuestionsListModalOpen) {
      setQuestionFormData((prev) => ({
        ...prev,
        assignment_id: currentAssignment.assignment_id,
      }));
    }
  }, [currentAssignment, isQuestionsListModalOpen]);

  const closeQuestionForm = () => {
    setQuestionFormData({
      question_id: "",
      assignment_id: "",
      course_id: courseId,
      question_name: "",
      option_a: "",
      option_b: "",
      option_c: "",
      option_d: "",
      correct_answer: "",
      marks: "",
      is_active: true,
    });
    setIsQuestionEditing(false);
  };

const closeQuestionsListModal = () => {
  setIsQuestionsListModalOpen(false);
  setCurrentAssignment(null);
  closeQuestionForm();
  setCurrentPage(1); // Reset page
  // Do NOT call refreshAssignmentsAndQuestions here
};

const openQuestionsList = async (assignment) => {
  setCurrentAssignment(assignment);
  setIsQuestionsListModalOpen(true);
  setIsQuestionEditing(false);
  setCurrentPage(1);

  // Always fetch fresh questions for this assignment
  try {
    const res = await fetch(SummaryApi.questionary_form_by_assignment.url, {
      method: SummaryApi.questionary_form_by_assignment.method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ assignment_id: assignment.assignment_id }),
    });
    const data = await res.json();
    
    if (data.status) {
      // Update the questionsMap with fresh data
      setQuestionsMap(prev => ({
        ...prev,
        [assignment.assignment_id]: data.data || []
      }));
    }
  } catch (err) {
    console.error("Error fetching fresh questions:", err);
  }

  // Reset form
  setQuestionFormData({
    question_id: "",
    assignment_id: assignment.assignment_id,
    course_id: courseId,
    question_name: "",
    option_a: "",
    option_b: "",
    option_c: "",
    option_d: "",
    correct_answer: "",
    marks: "",
    is_active: true,
  });
};

  const handleCancel = () => {
    setFormData({
      instructor_id: instructorId || "",
      course_id: courseId || "",
      time_slot_id: dynamicTimeSlotId || "",
      assignment_name: "",
      number_of_questions: "",
      is_active: true,
      assignment_id: "",
    });
    setIsEditing(false);
  };

  if (!dynamicTimeSlotId || isNaN(Number(dynamicTimeSlotId))) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-300">
        <p className="p-8 text-lg text-red-500 dark:text-red-400">
          Missing or invalid time slot ID in URL. Please provide ?time_slot_id=
          in the URL.
        </p>
      </div>
    );
  }

  if (loading || !dataReady || !course || !closedLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-300">
        <p className="p-8 text-lg text-gray-600 dark:text-gray-400">
          Loading course data...
        </p>
      </div>
    );
  }

  const generatePdfFromHtml = async (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;
    tempDiv.className = "certificate-template"; // Add the class for fixed sizing
    document.body.appendChild(tempDiv);

    try {
      const canvas = await html2canvas(tempDiv, {
        scale: 2, // Keep this for quality
        useCORS: true,
        allowTaint: false,
        width: 1100, // Explicit width
        height: 750, // Explicit height
        backgroundColor: "#ffffff",
        logging: false,
        scrollX: 0,
        scrollY: 0,
        windowWidth: 1100,
        windowHeight: 750,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: [1100, 750],
      });

      pdf.addImage(imgData, "PNG", 0, 0, 1100, 750);

      document.body.removeChild(tempDiv);

      return pdf.output("blob");
    } catch (error) {
      if (document.body.contains(tempDiv)) {
        document.body.removeChild(tempDiv);
      }
      console.error("PDF generation error:", error);
      throw error;
    }
  };
  const handleReviewStudent = async (student) => {
    const confirmed = await Swal.fire({
      title: "Review Student",
      text: `Are you sure you want to mark ${student.first_name} ${student.last_name} as reviewed?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#10b981",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Yes, Mark as Reviewed",
      cancelButtonText: "Cancel",
    });

    if (!confirmed.isConfirmed) return;

    try {
      const payload = {
        student_project_id: [student.student_project_id],
        is_review: 1,
        instructor_id: instructorId,
      };

      const response = await fetch(
        SummaryApi.instructor_project_review_update.url,
        {
          method: SummaryApi.instructor_project_review_update.method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (data.status) {
        toast.success(
          `Successfully marked ${student.first_name} ${student.last_name} as reviewed`
        );
        fetchEnrolledStudents();
      } else {
        toast.error(data.message || "Failed to update review status");
      }
    } catch (error) {
      console.error("Error updating review status:", error);
      toast.error("Error updating review status. Please try again.");
    }
  };

  const handleBulkGenerateCertificate = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (selectedStudents.length === 0) {
      toast.warning(
        "Please select at least one student to generate certificates"
      );
      return;
    }

    const confirmed = await Swal.fire({
      title: "Generate Certificates?",
      text: `Are you sure you want to generate certificates for ${
        selectedStudents.length
      } student${selectedStudents.length > 1 ? "s" : ""}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#10b981",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Yes, Generate",
      cancelButtonText: "Cancel",
    });

    if (!confirmed.isConfirmed) return;

    try {
      const loadingToast = toast.loading(
        `Generating certificates for ${selectedStudents.length} students...`
      );

      const promises = selectedStudents.map(async (studentProjectId) => {
        const student = enrolledStudents.find(
          (s) => s.student_project_id === studentProjectId
        );
        if (student && student.is_review === 1) {
          try {
            const certificateHtml = await generateCertificateEmail({
              student_name: `${student.first_name} ${student.last_name}`,
              course_title: course?.course_title || "Course",
              start_date: timeSlotDetails?.start_date
                ? formatDate(timeSlotDetails.start_date)
                : "N/A",
              end_date: timeSlotDetails?.end_date
                ? formatDate(timeSlotDetails.end_date)
                : "N/A",
            });

            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = certificateHtml;
            tempDiv.style.position = "absolute";
            tempDiv.style.left = "-9999px";
            tempDiv.style.top = "-9999px";
            tempDiv.className = "certificate-template"; // Add the fixed-size class
            document.body.appendChild(tempDiv);

            const canvas = await html2canvas(tempDiv, {
              scale: 2,
              useCORS: true,
              allowTaint: false,
              width: 1100,
              height: 750,
              backgroundColor: "#ffffff",
              logging: false,
              scrollX: 0,
              scrollY: 0,
            });

            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF({
              orientation: "landscape",
              unit: "px",
              format: [1100, 750],
            });

            pdf.addImage(imgData, "PNG", 0, 0, 1100, 750);

            document.body.removeChild(tempDiv);

            const pdfBlob = pdf.output("blob");

            const formData = new FormData();
            formData.append("student_id", student.student_id);
            formData.append("instructor_id", instructorId);
            formData.append(
              "enrollment_id",
              student.enrollment_id || student.student_project_id
            );
            formData.append(
              "file",
              pdfBlob,
              `certificate_${student.student_id}.pdf`
            );

            const response = await fetch(
              SummaryApi.student_generate_certification.url,
              {
                method: SummaryApi.student_generate_certification.method,
                body: formData,
              }
            );

            const result = await response.json();
            return {
              success: true,
              data: result,
              studentName: `${student.first_name} ${student.last_name}`,
            };
          } catch (pdfError) {
            console.error(
              `PDF generation failed for student ${student.student_id}:`,
              pdfError
            );
            return {
              success: false,
              error: "PDF generation failed",
              studentName: `${student.first_name} ${student.last_name}`,
            };
          }
        }
        return {
          success: false,
          error: "Student not found or not reviewed",
          studentName: "Unknown Student",
        };
      });

      const results = await Promise.all(promises);
      const successful = results.filter(
        (result) => result && result.success
      ).length;
      const failed = results.length - successful;

      toast.dismiss(loadingToast);

      if (successful > 0) {
        toast.success(
          `Successfully generated ${successful} certificate${
            successful > 1 ? "s" : ""
          }`
        );
      }
      if (failed > 0) {
        toast.warning(
          `${failed} certificate${failed > 1 ? "s" : ""} failed to generate`
        );
      }

      setSelectedStudents([]);
      fetchEnrolledStudents();
    } catch (error) {
      console.error("Error generating certificates:", error);
      toast.error("Error generating certificates. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-300">



      <div className="p-4 sm:p-6 max-w-8xl mx-auto bg-white dark:bg-gray-800 shadow rounded-[5px] transition-colors duration-300">
        
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6 bg-gradient-to-r from-teal-50 to-white dark:from-gray-700 dark:to-gray-800 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-600 transition-colors duration-300">
         <div> <button
    onClick={() => navigate(-1)}
    className="p-2 rounded-lg  
               text-gray-600 dark:text-gray-300 hover:text-[#1C3664] dark:hover:text-blue-400 
               transition-all duration-200"
    aria-label="Go back"
  >
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  </button></div> <div className="mb-3 sm:mb-0"> 
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold capitalize text-gray-800 dark:text-white tracking-wide transition-colors duration-300">
              {course.course_title}     

{timeSlotDetails?.is_course_completed === 1 && (
    <span className="ml-2 text-sm bg-green-600 text-white px-1 py-0.5 rounded-full">
                          Completed
                        </span>
  )}












            </h1>
            {timeSlotDetails && (
              <p className="text-gray-600 dark:text-gray-400 text-sm sm:text-base mt-1 transition-colors duration-300">
                ({formatDate(timeSlotDetails.start_date)} -{" "}
                {formatDate(timeSlotDetails.end_date)})
              </p>
            )}
          </div>
          <div className="text-left sm:text-right mt-2 sm:mt-0">
            <div className="text-sm sm:text-base md:text-lg text-gray-700 dark:text-gray-300 font-medium transition-colors duration-300">
              {curriculum.length} {curriculum.length === 1 ? "Topic" : "Topics"}{" "}
              |{" "}
              {Object.values(lessonsByCurriculum).reduce(
                (total, lessons) => total + lessons.length,
                0
              )}{" "}
              {Object.values(lessonsByCurriculum).reduce(
                (total, lessons) => total + lessons.length,
                0
              ) === 1
                ? "Lesson"
                : "Lessons"}
            </div>
            {calculateDaysLeft() !== null && (
              <>
                <div
                  className={`text-sm sm:text-base md:text-lg font-semibold mt-2 transition-all duration-300 ${
                    calculateDaysLeft() <= 7 && calculateDaysLeft() > 0
                      ? "text-green-600 dark:text-green-400"
                      : calculateDaysLeft() > 7
                      ? "text-green-600 dark:text-green-400"
                      : "text-green-600 dark:text-green-400"
                  }`}
                >
                  {calculateDaysLeft() > 7
                    ? `${calculateDaysLeft()} day${
                        calculateDaysLeft() > 1 ? "s" : ""
                      } left`
                    : calculateDaysLeft() === 7
                    ? "1 week left"
                    : calculateDaysLeft() > 0
                    ? `${calculateDaysLeft()} day${
                        calculateDaysLeft() > 1 ? "s" : ""
                      } left`
                    : "Course duration ended"}
                </div>
                <div className="w-full sm:w-48 h-2 bg-gray-200 dark:bg-gray-600 rounded-full mt-2 sm:ml-auto transition-colors duration-300">
                  <div
                    className={`h-2 rounded-full ${
                      calculateDaysLeft() > 7
                        ? "bg-green-500 dark:bg-green-400"
                        : calculateDaysLeft() > 0
                        ? "bg-yellow-500 dark:bg-yellow-400"
                        : "bg-red-600 dark:bg-red-400"
                    }`}
                    style={{
                      width: `${Math.max(
                        0,
                        100 -
                          (calculateDaysLeft() /
                            ((new Date(timeSlotDetails.end_date) -
                              new Date(timeSlotDetails.start_date)) /
                              (1000 * 60 * 60 * 24))) *
                            100
                      ).toFixed(0)}%`,
                    }}
                  ></div>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="mb-6">
          <div className="border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 rounded-lg shadow-sm transition-colors duration-300">
            <nav
              className="flex overflow-x-auto [&::-webkit-scrollbar]:h-1 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-gray-300 [&::-webkit-scrollbar-thumb]:rounded-full dark:[&::-webkit-scrollbar-thumb]:bg-gray-600 px-1 py-1 sm:px-3"
              aria-label="Tabs"
            >
              {[
                { id: "course-schedule", label: "Course Schedule", icon: "📅" },
                {
                  id: "course-curriculum",
                  label: "Course Curriculum",
                  icon: "📚",
                },
                { id: "assignments", label: "Assignments", icon: "📝" },
                { id: "project", label: "Project", icon: "💼" },
                { id: "enroll-students", label: "Enroll Students", icon: "👥" },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex-shrink-0 flex items-center px-3 py-1 text-sm font-medium transition-all duration-200 border-b-2 whitespace-nowrap mx-0.5 ${
                    activeTab === tab.id
                      ? "border-[#1C3664] dark:border-blue-400 text-[#1C3664] dark:text-blue-400 bg-gray-50 dark:bg-gray-700"
                      : "border-transparent text-gray-600 dark:text-gray-400 hover:text-[#1C3664] dark:hover:text-blue-400 hover:border-[#1C3664] dark:hover:border-blue-400"
                  }`}
                >
                  <span className="text-base mr-2">{tab.icon}</span>
                  {/* FIX: Show label on all screen sizes */}
                  <span className="inline">{tab.label}</span>
                </button>
              ))}
            </nav>
          </div>
        </div>
        {activeTab === "course-schedule" && (
          <div className="p-3 sm:p-4 bg-white dark:bg-gray-800 rounded-lg shadow transition-colors duration-300">
            <h2 className="text-lg sm:text-xl font-semibold mb-4 text-gray-800 dark:text-white transition-colors duration-300">
              Course Schedule
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm sm:text-base text-left text-gray-700 dark:text-gray-300 transition-colors duration-300">
                <thead className="text-sm sm:text-base uppercase bg-gray-100 dark:bg-gray-700 transition-colors duration-300">
                  <tr>
                    <th className="px-3 sm:px-4 py-3 sm:py-3">Day</th>
                    <th className="px-3 sm:px-4 py-3 sm:py-3">Time Slot</th>
                    <th className="px-3 sm:px-4 py-3 sm:py-3">Batch</th>
                    <th className="px-3 sm:px-4 py-3 sm:py-3">Start Date</th>
                    <th className="px-3 sm:px-4 py-3 sm:py-3">End Date</th>
                    <th className="px-3 sm:px-4 py-3 sm:py-3">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    const currentTimeSlot = timeSlots.find(
                      (slot) => slot.time_slot_id === Number(dynamicTimeSlotId)
                    );

                    if (!currentTimeSlot) {
                      return (
                        <tr>
                          <td
                            colSpan="6"
                            className="px-3 sm:px-4 py-3 sm:py-3 text-center text-gray-500 dark:text-gray-400 transition-colors duration-300"
                          >
                            No schedule found for the current time slot.
                          </td>
                        </tr>
                      );
                    }

                    return (
                      <tr
                        key={currentTimeSlot.time_slot_id}
                        className="border-b dark:border-gray-600 transition-colors duration-300"
                      >
                        <td className="px-3 sm:px-4 py-3 sm:py-3">
                          {[
                            "sunday",
                            "monday",
                            "tuesday",
                            "wednesday",
                            "thursday",
                            "friday",
                            "saturday",
                          ]
                            .filter((day) => currentTimeSlot[day] !== "N/A")
                            .map((day) => (
                              <div
                                key={day}
                                className="capitalize font-bold text-sm sm:text-base"
                              >
                                {day}
                              </div>
                            ))}
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-3">
                          {[
                            "sunday",
                            "monday",
                            "tuesday",
                            "wednesday",
                            "thursday",
                            "friday",
                            "saturday",
                          ]
                            .filter((day) => currentTimeSlot[day] !== "N/A")
                            .map((day) => (
                              <div key={day} className="text-sm sm:text-base">
                                {currentTimeSlot[day]
                                  .split("-")
                                  .map((time) => formatTimeDisplay(time))
                                  .join(" - ")}
                              </div>
                            ))}
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-3 text-sm sm:text-base">
                          {currentTimeSlot.batch_name}
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-3 text-sm sm:text-base">
                          {formatDate(currentTimeSlot.start_date)}
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-3 text-sm sm:text-base">
                          {formatDate(currentTimeSlot.end_date)}
                        </td>
                        <td className="px-3 sm:px-4 py-3 sm:py-3 text-sm sm:text-base">
                          {currentTimeSlot.is_course_completed
                            ? "Completed"
                            : currentTimeSlot.is_active
                            ? "Active"
                            : "Inactive"}
                        </td>
                      </tr>
                    );
                  })()}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === "course-curriculum" && (
          <div className="space-y-4">
<div className="flex justify-end">
  {/* Only show the button if course is NOT yet completed */}
  {timeSlotDetails?.is_course_completed !== 1 && (
    <button
      onClick={handleCompleteCourse}
      disabled={!isCourseCompleted}
      className={`
        px-4 py-1.5 rounded-md font-medium transition-all duration-300 text-sm flex items-center gap-2
        ${isCourseCompleted
          ? "bg-green-600 hover:bg-green-700 text-white cursor-pointer shadow-md"
          : "bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 cursor-not-allowed"
        }
      `}
    >
      {isCourseCompleted ? (
        <>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
          Mark Course as Completed
        </>
      ) : (
        <>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          Complete All Topics First
        </>
      )}
    </button>
  )}
</div>
            {curriculum.map(({ curriculum_id, topic_name }) => {
              const isOpen = openCurriculumId === curriculum_id;
              const isTopicClosed = closedTopics.some(
                (topic) =>
                  topic.curriculum_id === curriculum_id &&
                  topic.time_slot_id === Number(dynamicTimeSlotId) &&
                  topic.course_id === Number(courseId) &&
                  topic.is_closed === 1
              );
              return (
                <div
                  key={curriculum_id}
                  className="border rounded shadow-sm dark:border-gray-600 dark:bg-gray-800 transition-colors duration-300"
                >
                  <div
                    onClick={() => toggleCurriculum(curriculum_id)}
                    className="w-full flex items-center justify-between px-3 sm:px-5 py-1 sm:py-3 font-semibold rounded-t cursor-pointer bg-gray-50 dark:bg-gray-700 transition-colors duration-300"
                  >
                    <div className="flex items-center">
                      <span className="text-gray-800 dark:text-white transition-colors duration-300 text-base sm:text-lg">
                        {topic_name.trim()}
                      </span>
                      {isTopicClosed && (
                        <span className="ml-2 text-xs bg-green-600 text-white px-1 py-0.5 rounded-full">
                          Completed
                        </span>
                      )}
                    </div>
                    {isOpen ? (
                      <FiChevronDown className="text-xl text-gray-600 dark:text-gray-300" />
                    ) : (
                      <FiChevronRight className="text-xl text-gray-600 dark:text-gray-300" />
                    )}
                  </div>
                  {isOpen && (
                    <div className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-600 transition-colors duration-300">
                      {lessonsByCurriculum[curriculum_id]?.length > 0 ? (
                        <ul className="divide-y divide-gray-200 dark:divide-gray-600">
                          {lessonsByCurriculum[curriculum_id].map((lesson) => (
                            <li
                              key={lesson.lesson_id}
                              className={`p-3 sm:p-4 ${
                                lesson.is_closed
                                  ? "opacity-50 bg-gray-50 dark:bg-gray-700"
                                  : "bg-white dark:bg-gray-800"
                              } transition-colors duration-300`}
                            >
                              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0">
                                <div className="flex items-center">
                                  {lesson.is_closed ? (
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="mr-3 drop-shadow-lg flex-shrink-0"
                                    >
                                      <defs>
                                        <filter
                                          id="shadowGreen"
                                          x="0"
                                          y="0"
                                          width="200%"
                                          height="200%"
                                        >
                                          <feOffset
                                            result="offOut"
                                            in="SourceGraphic"
                                            dx="0"
                                            dy="2"
                                          />
                                          <feGaussianBlur
                                            result="blurOut"
                                            in="offOut"
                                            stdDeviation="2"
                                          />
                                          <feBlend
                                            in="SourceGraphic"
                                            in2="blurOut"
                                            mode="normal"
                                          />
                                        </filter>
                                        <linearGradient
                                          id="green3D"
                                          x1="0"
                                          y1="0"
                                          x2="24"
                                          y2="24"
                                          gradientUnits="userSpaceOnUse"
                                        >
                                          <stop stopColor="#2ECC71" />
                                          <stop
                                            offset="1"
                                            stopColor="#27AE60"
                                          />
                                        </linearGradient>
                                      </defs>

                                      {/* Circle background */}
                                      <circle
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        fill="url(#green3D)"
                                        filter="url(#shadowGreen)"
                                      />

                                      {/* Checkmark tick */}
                                      <path
                                        d="M9 12L11 14L15 10"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        fill="none"
                                      />
                                    </svg>
                                  ) : (
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 48 48"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="mr-3 drop-shadow-lg flex-shrink-0"
                                    >
                                      <defs>
                                        <filter
                                          id="shadowRed"
                                          x="0"
                                          y="0"
                                          width="200%"
                                          height="200%"
                                        >
                                          <feOffset
                                            result="offOut"
                                            in="SourceGraphic"
                                            dx="0"
                                            dy="2"
                                          />
                                          <feGaussianBlur
                                            result="blurOut"
                                            in="offOut"
                                            stdDeviation="2"
                                          />
                                          <feBlend
                                            in="SourceGraphic"
                                            in2="blurOut"
                                            mode="normal"
                                          />
                                        </filter>
                                      </defs>
                                      <path
                                        d="M10 8C10 5.79086 12.6863 4.47749 14.4853 5.75736L38.4853 22.7574C40.1949 23.9638 40.1949 26.5362 38.4853 27.7426L14.4853 44.7426C12.6863 46.0225 10 44.7091 10 42.5V8Z"
                                        fill="url(#red3D)"
                                        filter="url(#shadowRed)"
                                      />
                                      <linearGradient
                                        id="red3D"
                                        x1="10"
                                        y1="5"
                                        x2="40"
                                        y2="44"
                                        gradientUnits="userSpaceOnUse"
                                      >
                                        <stop stopColor="#E74C3C" />
                                        <stop offset="1" stopColor="#C0392B" />
                                      </linearGradient>
                                    </svg>
                                  )}
                                  <div>
                                    <span className="text-gray-800 dark:text-white font-medium transition-colors duration-300 text-base sm:text-lg">
                                      {lesson.lesson_name}
                                    </span>
                                    <span className="ml-2 sm:ml-3 text-sm sm:text-base text-gray-600 dark:text-gray-400 transition-colors duration-300">
                                      ({lesson.duration}{" "}
                                      {lesson.duration === 1 ? "min" : "mins"})
                                    </span>
                                  </div>
                                </div>
                                <div className="flex items-center justify-between sm:justify-end space-x-2 w-full sm:w-auto">
                                  {lesson.is_closed === 1 &&
                                    lesson.assignment_id > 0 && (
                                      <span className="bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 px-2 py-1 rounded-full text-sm font-medium border border-green-200 dark:border-green-700">
                                        Assignment submitted
                                      </span>
                                    )}
                                  {!lesson.is_closed && (
                                    <>
                                      {/* If assignment exists → show view button */}
                                      {/* {lesson.assignment_id ? (
      <button
        onClick={() => handleViewAssignment(lesson.assignment_id)}
        className="flex items-center gap-1 px-2 py-1 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-md hover:bg-blue-100 dark:hover:bg-blue-900/50 transition-colors border border-blue-100 dark:border-blue-800 text-sm"
      >
        <FiEye size={16} />
        View Assignment
      </button>

    ) : (
 
      <button 
        onClick={() => {
          if (assignments.length > 0) {
            handleAddAssignment(lesson.lesson_id);
          } else {
            setActiveTab("assignments");
          }
        }}
        className="px-2 py-1 bg-[#1f4774] dark:bg-blue-600 hover:bg-blue-700 dark:hover:bg-blue-700 text-white rounded-md transition-colors text-sm"
      >
        + Add Assignment
      </button>
    )} */}
                                      {lesson.assignment_id > 0 && (
                                        <button
                                          onClick={() =>
                                            handleViewAssignment(
                                              lesson.assignment_id
                                            )
                                          }
                                          className="flex items-center gap-1 px-2 py-1 bg-blue-50 dark:bg-blue-900/30 
               text-blue-700 dark:text-blue-300 rounded-md hover:bg-blue-100 
               dark:hover:bg-blue-900/50 transition-colors border 
               border-blue-100 dark:border-blue-800 text-sm"
                                        >
                                          <FiEye size={16} />
                                          View Assignment
                                        </button>
                                      )}

                                      {/* Dropdown for open lessons */}
                                      <div
                                        className="relative"
                                        ref={(el) =>
                                          (dropdownRefs.current[
                                            lesson.lesson_id
                                          ] = el)
                                        }
                                      >
                                        <button
                                          onClick={() =>
                                            setDropdownLessonId(
                                              dropdownLessonId ===
                                                lesson.lesson_id
                                                ? null
                                                : lesson.lesson_id
                                            )
                                          }
                                          className="p-1 sm:p-2 text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white drop-shadow-md transition-colors duration-300"
                                        >
                                          <FiMoreVertical size={18} />
                                        </button>

                                        {dropdownLessonId ===
                                          lesson.lesson_id && (
                                          <div className="absolute right-0 mt-2 w-36 sm:w-48 bg-white dark:bg-gray-700 border rounded shadow-xl z-10 transition-colors duration-300">
                                            <ul className="text-sm sm:text-base text-gray-700 dark:text-gray-300">
                                              <li
                                                className="px-3 sm:px-4 py-1 sm:py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors duration-300"
                                                onClick={() => {
                                                  handleCloseLesson(lesson);
                                                  setDropdownLessonId(null);
                                                }}
                                              >
                                                Mark as Closed
                                              </li>
                                            </ul>
                                          </div>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="p-4 text-center">
                          <p className="italic text-green-700 dark:text-green-400 text-base sm:text-lg">
                            No lessons found for this topic.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {activeTab === "assignments" && (
          <div className="p-3 sm:p-4 bg-white dark:bg-gray-800 rounded-lg shadow transition-colors duration-300">
            <h2 className="text-lg sm:text-xl font-bold text-gray-700 dark:text-white mb-4 transition-colors duration-300">
              {isEditing ? "Update Assignment" : "Create Assignment"}
            </h2>
            <form
              onSubmit={handleSubmit}
              className="bg-gray-50 dark:bg-gray-700 p-3 sm:p-4 md:p-6 rounded-lg shadow-md w-full transition-colors duration-300"
            >
              <div className="space-y-4">
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
                  <div>
                    <label
                      htmlFor="assignment_name"
                      className="block font-medium text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300 text-sm sm:text-base"
                    >
                      Assignment Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="assignment_name"
                      type="text"
                      name="assignment_name"
                      value={formData.assignment_name}
                      onChange={handleChange}
                      placeholder="Enter assignment name"
                      className="w-full border-gray-300 dark:border-gray-600 dark:bg-gray-600 dark:text-white rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 p-2 text-sm sm:text-base transition-colors duration-300"
                      required
                           disabled={timeSlotDetails?.is_course_completed === 1}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="number_of_questions"
                      className="block font-medium text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300 text-sm sm:text-base"
                    >
                      Number of Questions{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="number_of_questions"
                      type="number"
                      name="number_of_questions"
                      value={formData.number_of_questions}
                      onChange={handleChange}
                      placeholder="Enter number"
                      className="w-full border-gray-300 dark:border-gray-600 dark:bg-gray-600 dark:text-white rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 p-2 text-sm sm:text-base transition-colors duration-300"
                      required
                           disabled={timeSlotDetails?.is_course_completed === 1}
                      min="1"
                    />
                  </div>
                  {/* Topic (Curriculum) Dropdown */}
                  <div>
  <label
    htmlFor="curriculum_id"
    className="block font-medium text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300 text-sm sm:text-base"
  >
    Topic Name <span className="text-red-500">*</span>
  </label>
  <select
    id="curriculum_id"
    name="curriculum_id"
    value={formData.curriculum_id}
    onChange={handleTopicChange}
    className={`
      w-full border-gray-300 dark:border-gray-600 dark:bg-gray-600 dark:text-white 
      rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 p-2 
      text-sm sm:text-base transition-all duration-300
      ${
        // Disabled styles when: editing OR course completed
        isEditing || timeSlotDetails?.is_course_completed === 1
          ? "opacity-60 cursor-not-allowed bg-gray-100 dark:bg-gray-700"
          : ""
      }
    `}
    required
    disabled={isEditing || timeSlotDetails?.is_course_completed === 1}
  >
    <option value="">Select Topic</option>
    {topics.map((topic) => (
      <option
        key={topic.curriculum_id}
        value={topic.curriculum_id}
      >
        {topic.topic_name}
      </option>
    ))}
  </select>
</div>

                  
                  {/* Lesson Dropdown */}
<div>
  <label
    htmlFor="lesson_id"
    className="block font-medium text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300 text-sm sm:text-base"
  >
    Lesson Name <span className="text-red-500">*</span>
  </label>
  <select
    id="lesson_id"
    name="lesson_id"
    value={formData.lesson_id}
    onChange={handleChange}
    className={`w-full border-gray-300 dark:border-gray-600 dark:bg-gray-600 dark:text-white rounded-md shadow-sm focus:ring-blue-600 focus:border-blue-600 p-2 text-sm sm:text-base transition-colors duration-300 ${
      !formData.curriculum_id || isEditing
        ? "opacity-60 cursor-not-allowed bg-gray-100 dark:bg-gray-700"
        : ""
    }`}
    required
    // DISABLED IF: No topic selected OR currently editing
    disabled={!formData.curriculum_id || isEditing}
  >
    <option value="">Select Lesson</option>
    {topicLessons
      .filter((lesson) => {
        // 1. Show the lesson if it has NO assignment assigned to it
        const isUnassigned = !lesson.assignment_id || lesson.assignment_id === 0;

        // 2. IMPORTANT: If we are editing (or just selected a lesson), 
        // we MUST show the currently selected lesson, even if it has an assignment_id.
        // Otherwise, the dropdown value will be invalid/hidden.
        const isCurrentSelection = lesson.lesson_id === Number(formData.lesson_id);

        return isUnassigned || isCurrentSelection;
      })
      .map((lesson) => (
        <option key={lesson.lesson_id} value={lesson.lesson_id}>
          {lesson.lesson_name}
        </option>
      ))}
  </select>
</div>
                </div>
            <div className="flex items-center gap-3">
  <label className="text-gray-700 dark:text-gray-300 font-medium transition-colors duration-300 text-sm sm:text-base">
    Active
  </label>

  {/* Toggle Switch — Disabled when course is completed */}
  <div
    onClick={() => {
      if (timeSlotDetails?.is_course_completed !== 1) {
        handleToggle();
      }
    }}
    role="switch"
    aria-checked={formData.is_active}
    tabIndex={timeSlotDetails?.is_course_completed === 1 ? -1 : 0}
    onKeyDown={(e) => {
      if (timeSlotDetails?.is_course_completed !== 1 && e.key === "Enter") {
        handleToggle();
      }
    }}
    className={`
      relative inline-flex items-center h-6 rounded-full w-11 
      transition-all duration-300 select-none
      ${timeSlotDetails?.is_course_completed === 1
        ? "opacity-60 cursor-not-allowed"
        : "cursor-pointer"
      }
      ${formData.is_active
        ? "bg-blue-600"
        : "bg-gray-300 dark:bg-gray-600"
      }
    `}
    style={{
      cursor: timeSlotDetails?.is_course_completed === 1 ? 'not-allowed' : 'pointer'
    }}
  >
    <span
      className={`
        inline-block w-4 h-4 transform bg-white rounded-full 
        transition-transform duration-200
        ${formData.is_active ? "translate-x-6" : "translate-x-1"}
      `}
    />


  </div>
</div>
                <div className="flex justify-end gap-2">
                  {isEditing && (
                    <button
                      type="button"
                      onClick={handleCancel}
                      className="bg-gray-300 dark:bg-gray-600 text-gray-700 dark:text-gray-300 px-3 sm:px-4 py-1 rounded-md hover:bg-gray-400 dark:hover:bg-gray-500 transition-colors text-sm sm:text-base"
                    >
                      Cancel
                    </button>
                  )}
{/* ←←← THIS BUTTON WILL BE HIDDEN WHEN COURSE IS COMPLETED */}
  {timeSlotDetails?.is_course_completed !== 1 && (
    <button
      type="submit"
      disabled={loading}
      className={`flex items-center gap-2 bg-[#1C3664] dark:bg-blue-600 text-white px-3 sm:px-4 py-1 rounded-md hover:bg-blue-700 dark:hover:bg-blue-700 transition-colors text-sm sm:text-base ${
        loading ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      <FaSave />{" "}
      {loading ? "Saving..." : isEditing ? "Update Assignment" : "Save Assignment"}
    </button>
  )}
                </div>
              </div>
            </form>
            <div className="mt-6">
              <h2 className="text-lg font-bold text-gray-700 dark:text-white mb-4 transition-colors duration-300">
                Assignments Report
              </h2>
              <div className="overflow-x-auto">
                <table className="w-full bg-gray-50 dark:bg-gray-700 rounded-lg shadow-md text-xs sm:text-sm md:text-base transition-colors duration-300">
<thead>
  <tr className="bg-[#1C3664] dark:bg-blue-600 text-center text-white">
    <th className="px-2 sm:px-4 py-1 text-center">S.No</th>
    <th className="px-2 sm:px-4 py-1 text-center">
      Assignment Name
    </th>
    <th className="px-2 sm:px-4 py-1 text-center">
      Questions
    </th>
    <th className="px-2 sm:px-4 py-1 text-center">
      Questionaries
    </th>
    <th className="px-2 sm:px-4 py-1 text-center">Active</th>
    {/* Hide Actions header when course is completed */}
    {timeSlotDetails?.is_course_completed !== 1 && (
      <th className="px-2 sm:px-4 py-1 text-center">Actions</th>
    )}
  </tr>
</thead>  {/* THIS WAS MISSING */}
                  <tbody>
                    {assignments.length === 0 ? (
                      <tr>
                        <td
                          colSpan={6}
                          className="px-2 sm:px-4 py-2 text-center text-gray-500 dark:text-gray-400 transition-colors duration-300"
                        >
                          No assignments found.
                        </td>
                      </tr>
                    ) : (
                      assignments
                        .slice(
                          (currentPage - 1) * recordsPerPage,
                          currentPage * recordsPerPage
                        )
                        .map((assignment, index) => (
                          <tr
                            key={assignment.assignment_id}
                            className="border-b dark:border-gray-600 transition-colors duration-300"
                          >
                            <td className="px-2 sm:px-4 py-2 text-center text-gray-700 dark:text-gray-300">
                              {(currentPage - 1) * recordsPerPage + index + 1}
                            </td>
                            <td className="px-2 sm:px-4 py-2 text-center text-gray-700 dark:text-gray-300">
                              {assignment.assignment_name}
                            </td>
                            <td className="px-2 sm:px-4 py-2 text-center text-gray-700 dark:text-gray-300">
                              {assignment.number_of_questions}
                            </td>
         {/* ==== 4. Questionaries button – disable when course completed ==== */}
<td className="px-2 sm:px-4 py-2 text-center">
  <button
    onClick={() => openQuestionsList(assignment)}
    disabled={timeSlotDetails?.is_course_completed === 1}
    className={`text-blue-600 dark:text-blue-400 hover:underline transition-colors duration-300 text-xs sm:text-sm ${
      timeSlotDetails?.is_course_completed === 1
        ? "opacity-100 cursor-not-allowed"
        : ""
    }`}
  >
    {questionsMap[assignment.assignment_id]?.length || 0} /{" "}
    {assignment.number_of_questions}
  </button>
</td>
                            <td className="px-2 sm:px-4 py-2 text-center text-gray-700 dark:text-gray-300">
                              {assignment.is_active ? "Yes" : "No"}
                            </td>
              {timeSlotDetails?.is_course_completed !== 1 && (     <td className="px-2 sm:px-4 py-2 flex flex-wrap gap-1 sm:gap-2 justify-center">
     
              <>
                <button
                  onClick={() =>
                    handleEdit(assignment.assignment_id)
                  }
                  className="bg-[#1f4774] dark:bg-blue-600 hover:bg-blue-700 dark:hover:bg-blue-700 text-white px-2 sm:px-3 py-1 rounded-md transition-colors flex items-center gap-1 text-xs sm:text-sm"
                >
                  <FaPencilAlt /> Edit
                </button>
                <button
                  onClick={() => handleAddQuestion(assignment)}
                  disabled={
                    questionsMap[assignment.assignment_id]
                      ?.length >= assignment.number_of_questions
                  }
                  className={`bg-green-600 text-white px-2 sm:px-3 py-1 rounded-md transition-colors flex items-center gap-1 text-xs sm:text-sm ${
                    questionsMap[assignment.assignment_id]
                      ?.length >= assignment.number_of_questions
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:bg-green-700"
                  }`}
                >
                  Add Question
                </button>
              </>
       
</td>     )}
                          </tr>
                        ))
                    )}
                  </tbody>
                </table>
                {Math.ceil(assignments.length / recordsPerPage) > 1 && (
                  <div className="flex flex-col sm:flex-row justify-between items-center mt-4 px-2 sm:px-4 py-2 bg-gray-100 dark:bg-gray-600 rounded-b-lg transition-colors duration-300 gap-2">
                    <div className="text-gray-700 dark:text-gray-300 text-xs sm:text-sm">
                      Total Records: {assignments.length}
                    </div>
                    <div className="flex items-center gap-1 sm:gap-2">
                      <button
                        onClick={() => setCurrentPage(1)}
                        disabled={currentPage === 1}
                        className="px-2 sm:px-3 py-1 bg-blue-600 dark:bg-blue-600 text-white rounded-md hover:bg-blue-700 dark:hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm transition-colors duration-300"
                      >
                        &lt;&lt;
                      </button>
                      <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="px-2 sm:px-3 py-1 bg-blue-600 dark:bg-blue-600 text-white rounded-md hover:bg-blue-700 dark:hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm transition-colors duration-300"
                      >
                        &lt;
                      </button>
                      <span className="text-gray-700 dark:text-gray-300 text-xs sm:text-sm">
                        Page {currentPage} of{" "}
                        {Math.ceil(assignments.length / recordsPerPage)}
                      </span>
                      <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={
                          currentPage ===
                          Math.ceil(assignments.length / recordsPerPage)
                        }
                        className="px-2 sm:px-3 py-1 bg-blue-600 dark:bg-blue-600 text-white rounded-md hover:bg-blue-700 dark:hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm transition-colors duration-300"
                      >
                        &gt;
                      </button>
                      <button
                        onClick={() =>
                          setCurrentPage(
                            Math.ceil(assignments.length / recordsPerPage)
                          )
                        }
                        disabled={
                          currentPage ===
                          Math.ceil(assignments.length / recordsPerPage)
                        }
                        className="px-2 sm:px-3 py-1 bg-blue-600 dark:bg-blue-600 text-white rounded-md hover:bg-blue-700 dark:hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm transition-colors duration-300"
                      >
                        &gt;&gt;
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {activeTab === "project" && (
          <div className="p-3 sm:p-4 bg-white dark:bg-gray-800 rounded-lg shadow transition-colors duration-300">
            <h2 className="text-lg sm:text-xl font-bold text-gray-700 dark:text-white mb-4 transition-colors duration-300">
              {project ? "Update Project Details" : "Create Project Details"}
            </h2>

            <form
              onSubmit={handleSaveProject}
              className="bg-gray-50 dark:bg-gray-700 p-3 sm:p-4 rounded-lg shadow-md transition-colors duration-300"
            >
              <div className="grid grid-cols-1 gap-3 sm:gap-4 md:grid-cols-2">
                <div>
                  <label className="block mb-1 font-medium text-gray-700 dark:text-gray-300 transition-colors duration-300 text-sm sm:text-base">
                    Project Title:
                  </label>
                  <input
                    type="text"
                    name="project_title"
                    defaultValue={project?.project_title || ""}
                    className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-600 dark:text-white rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-300 text-sm sm:text-base"
                    placeholder="Enter project title"
                    required
                    disabled={timeSlotDetails?.is_course_completed === 1}
                  />
                </div>
                <div>
                  <label className="block mb-1 font-medium text-gray-700 dark:text-gray-300 transition-colors duration-300 text-sm sm:text-base">
                    Subtitle:
                  </label>
                  <input
                    type="text"
                    name="subtitle"
                    defaultValue={project?.subtitle || ""}
                    className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-600 dark:text-white rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-300 text-sm sm:text-base"
                    placeholder="Enter subtitle (optional)"
                               disabled={timeSlotDetails?.is_course_completed === 1}     />

                </div>
                <div>
                  <label className="block mb-1 font-medium text-gray-700 dark:text-gray-300 transition-colors duration-300 text-sm sm:text-base">
                    Submission Date:
                  </label>
                  <input
                    type="date"
                    name="submission_date"
                    defaultValue={
                      project?.submission_date
                        ? formatDateForInput(project.submission_date)
                        : ""
                    }
                    className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-600 dark:text-white rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-300 text-sm sm:text-base"
                    required
                    disabled={timeSlotDetails?.is_course_completed === 1}
                  />
                </div>
              </div>

              <div className="mt-3 sm:mt-4">
                <label className="block mb-1 font-medium text-gray-700 dark:text-gray-300 transition-colors duration-300 text-sm sm:text-base">
                  Description:
                </label>
                <textarea
                  name="description"
                  defaultValue={project?.description || ""}
                  className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-600 dark:text-white rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 h-20 sm:h-24 transition-colors duration-300 text-sm sm:text-base"
                  placeholder="Enter project description"
                  disabled={timeSlotDetails?.is_course_completed === 1}
                />
              </div>

              <div className="flex items-center gap-3 mt-3 sm:mt-4">
  <label className="text-gray-700 dark:text-gray-300 font-medium transition-colors duration-300 text-sm sm:text-base">
    Active
  </label>

  {/* Toggle Switch — Locked when course is completed */}
  <div
    onClick={() => {
      if (timeSlotDetails?.is_course_completed !== 1) {
        setProjectActive(!projectActive);
      }
    }}
    role="switch"
    aria-checked={projectActive}
    tabIndex={timeSlotDetails?.is_course_completed === 1 ? -1 : 0}
    onKeyDown={(e) => {
      if (timeSlotDetails?.is_course_completed !== 1 && e.key === "Enter") {
        e.preventDefault();
        setProjectActive(!projectActive);
      }
    }}
    className={`
      relative inline-flex items-center h-6 rounded-full w-11 
      transition-all duration-300 select-none
      ${timeSlotDetails?.is_course_completed === 1
        ? "opacity-60 cursor-not-allowed"
        : "cursor-pointer"
      }
      ${projectActive ? "bg-blue-600" : "bg-gray-300 dark:bg-gray-600"}
    `}
    style={{
      cursor: timeSlotDetails?.is_course_completed === 1 ? 'not-allowed' : 'pointer'
    }}
  >
    <span
      className={`
        inline-block w-4 h-4 transform bg-white rounded-full 
        transition-transform duration-200
        ${projectActive ? "translate-x-6" : "translate-x-1"}
      `}
    />

  </div>

  {/* Hidden checkbox — unchanged */}
  <input
    type="checkbox"
    name="is_active"
    className="hidden"
    checked={projectActive}
    readOnly
  />
</div>

              <div className="mt-3 sm:mt-4">
                <label className="block font-medium text-gray-700 dark:text-gray-300 mb-2 transition-colors duration-300 text-sm sm:text-base">
                  Project Image:
                </label>
                <div className="flex items-center gap-3 sm:gap-4">
                  <div className="relative flex-shrink-0">
               <div
        className={`
          w-32 h-24 sm:w-40 sm:h-28 
          bg-gray-200 dark:bg-gray-600 
          flex flex-col items-center justify-center 
          rounded-lg border-2 border-dashed 
          transition-all duration-300
          ${timeSlotDetails?.is_course_completed === 1
            ? "cursor-not-allowed opacity-75"
            : "cursor-pointer hover:border-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700"
          }
        `}
        style={{
          cursor: timeSlotDetails?.is_course_completed === 1 ? 'not-allowed' : 'pointer'
        }}
        onClick={(e) => {
          if (timeSlotDetails?.is_course_completed === 1) {
            e.preventDefault();
            e.stopPropagation();
          } else {
            document.getElementById("imageUpload").click();
          }
        }}
      >
                      {previewImage ? (
                        <img
                          src={previewImage}
                          alt="Project Preview"
                          className="w-full h-full object-contain"
                        />
                      ) : (
                        <div className="text-center">
                          <FiCamera className="text-gray-500 dark:text-gray-400 text-2xl sm:text-3xl mx-auto mb-1 transition-colors duration-300" />
                          <span className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 transition-colors duration-300">
                            Upload Project Image
                          </span>
                        </div>
                      )}
                    </div>
                    <input
                      id="imageUpload"
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleImageUpload}
                                        disabled={timeSlotDetails?.is_course_completed === 1}
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-end space-x-2 sm:space-x-3 mt-4 sm:mt-6 pt-3 sm:pt-4 border-t border-gray-200 dark:border-gray-600 transition-colors duration-300">
{timeSlotDetails?.is_course_completed !== 1 && (
    <button
      type="submit"
      disabled={projectLoading}
      className={`px-3 sm:px-4 py-1 bg-[#1C3664] dark:bg-blue-600 text-white rounded hover:bg-blue-700 dark:hover:bg-blue-700 transition-colors text-sm sm:text-base flex items-center gap-2 ${
        projectLoading ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      {projectLoading ? (
        <>
          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          Saving...
        </>
      ) : (
        <>
          <FaSave size={14} />
          {project ? "Update Project" : "Create Project"}
        </>
      )}
    </button>
  )}
              </div>
            </form>
          </div>
        )}

        {/* Bulk Action Buttons */}
        {selectedStudents.length > 0 && (
          <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900 border border-blue-200 dark:border-blue-700 rounded-lg transition-colors duration-300">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <span className="text-blue-700 dark:text-blue-300 font-medium text-sm sm:text-base">
                {selectedStudents.length} student
                {selectedStudents.length > 1 ? "s" : ""} selected
              </span>
              <div className="flex gap-2">
                {/* Check if all selected students are reviewed */}
                {selectedStudents.every((id) => {
                  const student = enrolledStudents.find(
                    (s) => s.student_project_id === id
                  );
                  return student?.is_review === 1;
                }) ? (
                  <button
                    onClick={(e) => handleBulkGenerateCertificate(e)}
                    className="px-3 sm:px-4 py-1 bg-green-600 hover:bg-green-700 text-white rounded transition-colors font-medium text-sm sm:text-base whitespace-nowrap"
                    type="button" // Important: Add type="button" to prevent form submission
                  >
                    Generate Certificates
                  </button>
                ) : (
                  <button
                    onClick={handleBulkReview}
                    className="px-3 sm:px-4 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors font-medium text-sm sm:text-base whitespace-nowrap"
                  >
                    Mark as Reviewed
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {activeTab === "enroll-students" && (
          <div className="p-3 sm:p-4 bg-white dark:bg-gray-800 rounded-lg shadow transition-colors duration-300">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4 gap-2">
              <h2 className="text-lg sm:text-xl font-semibold text-gray-800 dark:text-white transition-colors duration-300">
                Enrolled Students
              </h2>
              <div className="text-base font-medium text-gray-600 dark:text-gray-400 transition-colors duration-300">
                Total Enrolled:{" "}
                <span className="text-blue-600 dark:text-blue-400">
                  {enrolledStudents.length}
                </span>
              </div>
            </div>

            {loading ? (
              <div className="flex justify-center items-center py-8">
                <p className="text-gray-600 dark:text-gray-400 text-base">
                  Loading enrolled students...
                </p>
              </div>
            ) : enrolledStudents.length === 0 ? (
              <div className="text-center py-8">
                <p className="text-gray-600 dark:text-gray-400 text-base">
                  No students enrolled for this time slot.
                </p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="w-full bg-gray-50 dark:bg-gray-700 rounded-lg shadow-md text-sm sm:text-base md:text-lg transition-colors duration-300">
                  <thead className="text-sm sm:text-base uppercase bg-gray-100 dark:bg-gray-600 transition-colors duration-300">
                    <tr>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                        Select
                      </th>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                        S.No
                      </th>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                        Student Name
                      </th>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                        Email
                      </th>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                        Mobile
                      </th>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
  Enrolled Date
</th>
                      {/* In the table headers (find this section in enroll students) */}
<th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
  Assignment Scores
</th>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                        Project status
                      </th>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                        Review Status
                      </th>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                        Course Completed Date
                      </th>
                      <th className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                        Certificate Generated
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {enrolledStudents.map((student, index) => {
                      // Check if student should be disabled for selection
                      const isCertificateGenerated =
                        student.is_generate_certificate === 1;
                      const isReviewed = student.is_review === 1;
                      const shouldDisableSelection =
                        isCertificateGenerated && isReviewed;

                      return (
                        <tr
                          key={student.student_id}
                          className="border-b dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors duration-300"
                        >
                          <td className="px-2 sm:px-4 py-3 text-center align-middle">
                            <input
                              type="checkbox"
                              checked={selectedStudents.includes(
                                student.student_project_id
                              )}
                              onChange={() =>
                                handleSelectStudent(student.student_project_id)
                              }
                              disabled={
                                !student.project_is_active ||
                                shouldDisableSelection
                              }
                              className={`
                        w-4 h-4 sm:w-5 sm:h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 mx-auto block
                        ${
                          !student.project_is_active || shouldDisableSelection
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }
                      `}
                            />
                          </td>
                          <td className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                            {index + 1}
                          </td>
                          <td className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                            {student.first_name} {student.last_name}
                          </td>
                          <td className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300 text-sm sm:text-base">
                            {student.email}
                          </td>
                          <td className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300">
                            {student.mobile_number}
                          </td>
<td className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300 text-sm sm:text-base">
  {student.enrollment_date ? formatDate(student.enrollment_date) : "N/A"}
</td>






                          {/* Inside the enrolledStudents.map, add this td in the row */}
<td className="px-2 sm:px-4 py-3 text-center align-middle">
  <button
    onClick={() => {
      fetchAssignmentScores(student);
      setShowAssignmentScoreModal(true);
    }}
    className="flex items-center justify-center gap-1 bg-blue-600 hover:bg-blue-700 text-white px-2 py-1 rounded text-xs sm:text-sm transition-colors duration-300 mx-auto"
  >
    <FaChartBar size={12} />
    View Scores
  </button>
</td>
      <td className="px-2 sm:px-4 py-3 text-center align-middle">
  <button
    onClick={(e) => {
      e.stopPropagation();
      setSelectedStudentProject(student);
      setShowProjectDetailsModal(true);
    }}
    className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 font-medium text-sm sm:text-base underline transition"
  >
    View Project
  </button>
</td>

        
                          <td className="px-2 sm:px-4 py-3 text-center align-middle">
                            {student.is_review === 0 ? (
                              <span className="text-red-600 dark:text-red-400 font-medium text-sm sm:text-base">
                                Need to Review
                              </span>
                            ) : student.is_review === 1 ? (
                              <span className="text-green-600 dark:text-green-400 font-medium text-sm sm:text-base">
                                Reviewed
                              </span>
                            ) : (
                              <span className="text-yellow-600 dark:text-yellow-400 font-medium text-sm sm:text-base">
                                Pending
                              </span>
                            )}
                          </td>
                          <td className="px-2 sm:px-4 py-3 text-center align-middle text-gray-700 dark:text-gray-300 text-sm sm:text-base">
                            {student.course_completed_date
                              ? formatDate(student.course_completed_date)
                              : "N/A"}
                          </td>

                          <td className="px-2 sm:px-4 py-3 text-center align-middle">
                            {isCertificateGenerated ? (
                              <span className="text-green-600 dark:text-green-400 font-medium text-sm sm:text-base">
                                Yes
                              </span>
                            ) : (
                              <span className="text-red-600 dark:text-red-400 font-medium text-sm sm:text-base">
                                No
                              </span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* Assignment Modal */}
        {showAssignmentModal && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4">
            <div className="bg-white dark:bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-auto transition-colors duration-300 relative">
              {/* Close Button */}
              <button
                onClick={() => {
                  setShowAssignmentModal(false);
                  setSelectedAssignmentId("");
                  setSelectedLessonId(null);
                }}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 transition-colors"
              >
                <FiX size={20} />
              </button>
              <div className="space-y-4">
                {assignments.length === 0 ? (
                  // Show this when no assignments exist
                  <div className="text-center py-4">
                    <div className="mx-auto w-16 h-16 bg-yellow-100 dark:bg-yellow-900 rounded-full flex items-center justify-center mb-3">
                      <svg
                        className="w-8 h-8 text-yellow-600 dark:text-yellow-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2">
                      No Assignments Available
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400 mb-4 text-sm">
                      There are no assignments created for this course yet.
                      Please create assignments first.
                    </p>
                    <button
                      onClick={() => {
                        setShowAssignmentModal(false);
                        setActiveTab("assignments");
                      }}
                      className="w-full bg-[#1f4774] dark:bg-blue-600 hover:bg-blue-700 dark:hover:bg-blue-700 text-white py-1 px-4 rounded-md transition-colors duration-200 flex items-center justify-center gap-2"
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                      Create New Assignment
                    </button>
                  </div>
                ) : (
                  // Show this when assignments exist
                  <>
                    <div>
                      <label className="block mb-2 font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-base">
                        Select Assignment:
                      </label>
                      <select
                        className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded transition-colors duration-300 text-sm sm:text-base"
                        value={selectedAssignmentId}
                        onChange={(e) =>
                          setSelectedAssignmentId(e.target.value)
                        }
                      >
                        <option value="">Choose an assignment</option>
                        {assignments.map((assignment) => (
                          <option
                            key={assignment.assignment_id}
                            value={assignment.assignment_id}
                          >
                            {assignment.assignment_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex justify-end space-x-2 sm:space-x-3">
                      <button
                        onClick={() => {
                          setShowAssignmentModal(false);
                          setSelectedAssignmentId("");
                          setSelectedLessonId(null);
                        }}
                        className="px-3 sm:px-4 py-1 bg-gray-300 dark:bg-gray-600 text-gray-800 dark:text-gray-300 rounded hover:bg-gray-400 dark:hover:bg-gray-500 transition-colors text-sm sm:text-base"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => {
                          if (selectedAssignmentId && selectedLessonId) {
                            handleAddAssignment(
                              selectedLessonId,
                              selectedAssignmentId
                            );
                          } else {
                            toast.warning("Please select an assignment");
                          }
                        }}
                        className="px-3 sm:px-4 py-1 bg-[#1f4774] dark:bg-blue-600 hover:bg-blue-700 dark:hover:bg-blue-700 text-white rounded transition-colors text-sm sm:text-base"
                      >
                        Add Assignment
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Project Modal */}
        {showProjectModal && (
          <div
            className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-2 sm:p-4"
            onClick={handleModalBackgroundClick}
          >
            <div className="bg-white dark:bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-2xl mx-auto max-h-[90vh] overflow-y-auto relative transition-colors duration-300">
              <button
                onClick={() => setShowProjectModal(false)}
                className="absolute top-2 right-2 sm:top-4 sm:right-4 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
              >
                <FiX size={20} />
              </button>
              <h2 className="text-lg sm:text-xl font-semibold mb-4 text-center pr-6 sm:pr-8 text-gray-800 dark:text-white">
                {project ? "Update Project Details" : "Create Project Details"}
              </h2>
              <form
                onSubmit={handleSaveProject}
                className="space-y-4 sm:space-y-6"
              >
                <div className="grid grid-cols-1 gap-3 sm:gap-4">
                  <div>
                    <label className="block mb-1 font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-base">
                      Project Name:
                    </label>
                    <input
                      type="text"
                      name="project_name"
                      defaultValue={project?.project_name || ""}
                      className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-300 text-sm sm:text-base"
                      placeholder="Enter project name"
                      required
                    />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="block mb-1 font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-base">
                        Project Title:
                      </label>
                      <input
                        type="text"
                        name="project_title"
                        defaultValue={project?.project_title || ""}
                        className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-300 text-sm sm:text-base"
                        placeholder="Enter project title"
                        required
                      />
                    </div>
                    <div>
                      <label className="block mb-1 font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-base">
                        Subtitle:
                      </label>
                      <input
                        type="text"
                        name="subtitle"
                        defaultValue={project?.subtitle || ""}
                        className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-300 text-sm sm:text-base"
                        placeholder="Enter subtitle (optional)"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block mb-1 font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-base">
                      Description:
                    </label>
                    <textarea
                      name="description"
                      defaultValue={project?.description || ""}
                      className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 h-20 sm:h-24 transition-colors duration-300 text-sm sm:text-base"
                      placeholder="Enter project description"
                    />
                  </div>
                  <div>
                    <label className="block mb-1 font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-base">
                      Submission Date:
                    </label>
                    <input
                      type="date"
                      name="submission_date"
                      defaultValue={
                        project?.submission_date
                          ? formatDateForInput(project.submission_date)
                          : ""
                      }
                      className="w-full p-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-300 text-sm sm:text-base"
                      required
                    />
                  </div>
                  <div className="flex items-center">
                    <label className="flex items-center cursor-pointer">
                      <div className="relative">
                        <input
                          type="checkbox"
                          name="is_active"
                          className="sr-only"
                          defaultChecked={
                            project ? project.is_active === 1 : true
                          }
                        />
                        <div
                          className={`block w-12 sm:w-14 h-6 sm:h-8 rounded-full ${
                            project
                              ? project.is_active === 1
                                ? "bg-green-500"
                                : "bg-gray-400 dark:bg-gray-600"
                              : "bg-green-500"
                          } transition-colors duration-300`}
                        ></div>
                        <div
                          className={`dot absolute left-1 top-1 bg-white w-4 sm:w-6 h-4 sm:h-6 rounded-full transition-transform ${
                            project
                              ? project.is_active === 1
                                ? "transform translate-x-6 sm:translate-x-6"
                                : ""
                              : "transform translate-x-6 sm:translate-x-6"
                          } transition-colors duration-300`}
                        ></div>
                      </div>
                      <div className="ml-3 text-gray-700 dark:text-gray-300 font-medium text-sm sm:text-base">
                        {project
                          ? project.is_active === 1
                            ? "Active"
                            : "Inactive"
                          : "Active"}
                      </div>
                    </label>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mt-4 sm:mt-6 border-t pt-3 sm:pt-4 border-gray-200 dark:border-gray-600 gap-3">
                  <label className="block font-medium text-gray-700 dark:text-gray-300 mr-4 whitespace-nowrap text-sm sm:text-base">
                    Project Image:
                  </label>
                  <div className="relative flex-shrink-0">
                    <div
                      className="w-32 h-24 sm:w-40 sm:h-28 bg-gray-200 dark:bg-gray-600 flex items-center justify-center cursor-pointer overflow-hidden border-2 border-dashed border-gray-300 dark:border-gray-500 rounded-lg transition-colors duration-300"
                      onClick={() =>
                        document.getElementById("imageUpload").click()
                      }
                    >
                      {previewImage ? (
                        <img
                          src={previewImage}
                          alt="Project Preview"
                          className="w-full h-full object-contain"
                        />
                      ) : (
                        <div className="text-center">
                          <FiCamera className="text-gray-500 dark:text-gray-400 text-2xl sm:text-3xl mx-auto mb-1 transition-colors duration-300" />
                          <span className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 transition-colors duration-300">
                            Upload Project Image
                          </span>
                        </div>
                      )}
                    </div>
                    <input
                      id="imageUpload"
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={handleImageUpload}
                    />
                  </div>
                </div>
                <div className="flex justify-end space-x-2 sm:space-x-3 pt-3 sm:pt-4 border-t border-gray-200 dark:border-gray-600">
                  <button
                    type="button"
                    onClick={() => setShowProjectModal(false)}
                    disabled={projectLoading}
                    className={`px-3 sm:px-4 py-1 bg-gray-300 dark:bg-gray-600 text-gray-800 dark:text-gray-300 rounded hover:bg-gray-400 dark:hover:bg-gray-500 transition-colors text-sm sm:text-base ${
                      projectLoading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={projectLoading}
                    className={`px-3 sm:px-4 py-1 bg-[#1C3664] dark:bg-blue-600 text-white rounded hover:bg-blue-700 dark:hover:bg-blue-700 transition-colors text-sm sm:text-base flex items-center gap-2 ${
                      projectLoading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    {projectLoading ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        {project ? "Updating..." : "Creating..."}
                      </>
                    ) : project ? (
                      "Update Project"
                    ) : (
                      "Create Project"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Assignment Details Modal */}
        {showAssignmentDetails && viewedAssignment && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4">
            <div className="bg-white dark:bg-gray-800 p-4 sm:p-6 rounded shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto mx-auto transition-colors duration-300 relative">
              {/* Close Button */}
              <button
                onClick={() => setShowAssignmentDetails(false)}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors duration-200"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-gray-800 dark:text-white pr-8">
                Assignment Details
              </h2>

              {/* Assignment Basic Info */}
              <div className="space-y-3 mb-6">
                <div className="flex justify-between items-center border-b pb-2">
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    Assignment Name:
                  </span>
                  <span className="text-gray-800 dark:text-white font-semibold">
                    {viewedAssignment.assignment_name}
                  </span>
                </div>

                <div className="flex justify-between items-center border-b pb-2">
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    Total Questions:
                  </span>
                  <span className="text-blue-600 dark:text-blue-400 font-semibold">
                    {viewedAssignment.questions?.length || 0} /{" "}
                    {viewedAssignment.number_of_questions}
                  </span>
                </div>

                <div className="flex justify-between items-center border-b pb-2">
                  <span className="font-medium text-gray-700 dark:text-gray-300">
                    Created Date:
                  </span>
                  <span className="text-gray-600 dark:text-gray-400 text-sm">
                    {viewedAssignment.created_date
                      ? new Date(
                          viewedAssignment.created_date
                        ).toLocaleDateString("en-GB")
                      : "N/A"}
                  </span>
                </div>

                {/* Total Marks */}
                <div className="bg-blue-50 dark:bg-blue-900/30 p-3 rounded-lg">
                  <div className="flex justify-between items-center">
                    <span className="font-medium text-blue-700 dark:text-blue-300">
                      Total Marks:
                    </span>
                    <span className="text-blue-700 dark:text-blue-300 font-bold text-lg">
                      {viewedAssignment.questions?.reduce(
                        (total, question) =>
                          total + (parseInt(question.marks) || 0),
                        0
                      ) || 0}{" "}
                      marks
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {isQuestionsListModalOpen && currentAssignment && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-1 sm:p-2 md:p-4"
            onClick={(e) => {
              if (e.target === e.currentTarget) closeQuestionsListModal();
            }}
          >
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full max-w-4xl max-h-[92vh] overflow-y-auto border border-gray-300 dark:border-gray-600 relative transition-colors duration-300">
              {/* Close Button */}
              <button
                onClick={closeQuestionsListModal}
                className="absolute top-1 right-1 sm:top-2 sm:right-2 md:top-3 md:right-3 text-gray-500 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 transition z-10"
              >
                <FaTimes size={18} />
              </button>

              <div className="p-2 sm:p-3 md:p-5">
                {/* Title */}
                <h2 className="text-sm sm:text-md md:text-lg font-bold text-gray-800 dark:text-white mb-2 text-center sm:text-left transition-colors duration-300">
                  Questions for{" "}
                  <span className="text-blue-600 dark:text-blue-400">
                    {currentAssignment.assignment_name}
                  </span>
                </h2>

                {/* LIMIT COUNTER */}
                {(() => {
                  const existing =
                    questionsMap[currentAssignment.assignment_id]?.length || 0;
                  const limit = currentAssignment.number_of_questions;
                  const isFull = existing >= limit;

                  return (
                    <div
                      className={`mb-2 sm:mb-3 p-1 sm:p-2 rounded text-center text-sm sm:text-md font-semibold transition-all ${
                        isFull
                          ? "bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300 border border-red-300 dark:border-red-700"
                          : "bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 border border-green-300 dark:border-green-700"
                      }`}
                    >
                      {existing} / {limit} questions added
                      {isFull && " — Limit reached"}
                    </div>
                  );
                })()}

                {/* COMPACT FORM */}
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-700 dark:to-gray-800 p-2 sm:p-3 rounded-lg border border-blue-200 dark:border-gray-600 mb-3 sm:mb-4 transition-colors duration-300">
                  <h3 className="text-sm sm:text-md font-semibold text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">
                    {isQuestionEditing ? "Update Question" : "Add New Question"}
                  </h3>

                  <form
                    onSubmit={handleQuestionSubmit}
                    className="grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-2"
                  >
                    <input
                      type="hidden"
                      name="question_id"
                      value={questionFormData.question_id}
                    />
                    <input
                      type="hidden"
                      name="assignment_id"
                      value={questionFormData.assignment_id}
                    />
                    <input
                      type="hidden"
                      name="course_id"
                      value={questionFormData.course_id}
                    />

                    {/* Question */}
                    <div className="sm:col-span-2">
                      <label className="block font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-md mb-0.5">
                        Question *
                      </label>
                      <input
                        type="text"
                        name="question_name"
                        value={questionFormData.question_name}
                        onChange={handleQuestionChange}
                        placeholder="Enter question"
                        className="w-full py-1 sm:py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-1 focus:ring-blue-500 text-sm sm:text-md transition-colors duration-300"
                        required
                      />
                    </div>

                    {/* Options */}
                    {["A", "B", "C", "D"].map((opt) => (
                      <div key={opt}>
                        <label className="block font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-md mb-0.5">
                          Option {opt} *
                        </label>
                        <input
                          type="text"
                          name={`option_${opt.toLowerCase()}`}
                          value={
                            questionFormData[`option_${opt.toLowerCase()}`]
                          }
                          onChange={handleQuestionChange}
                          placeholder={opt}
                          className="w-full py-1 sm:py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-1 focus:ring-blue-500 text-sm sm:text-md transition-colors duration-300"
                          required
                        />
                      </div>
                    ))}

                    {/* Correct Answer & Marks */}
                    <div>
                      <label className="block font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-md mb-0.5">
                        Correct Answer *
                      </label>
                      <select
                        name="correct_answer"
                        value={questionFormData.correct_answer}
                        onChange={handleQuestionChange}
                        className="w-full py-1 sm:py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-1 focus:ring-blue-500 text-sm sm:text-md transition-colors duration-300"
                        required
                      >
                        <option value="">Select</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="C">C</option>
                        <option value="D">D</option>
                      </select>
                    </div>
                    <div>
                      <label className="block font-medium text-gray-700 dark:text-gray-300 text-sm sm:text-md mb-0.5">
                        Marks *
                      </label>
                      <input
                        type="number"
                        name="marks"
                        value={questionFormData.marks}
                        onChange={handleQuestionChange}
                        placeholder="5"
                        className="w-full py-1 sm:py-1.5 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded focus:ring-1 focus:ring-blue-500 text-sm sm:text-md transition-colors duration-300"
                        required
                        min="1"
                      />
                    </div>

                    {/* Toggle + Buttons */}
                    <div className="sm:col-span-2 flex flex-col sm:flex-row items-center justify-between gap-1 sm:gap-2 mt-1">
                      <div className="flex items-center gap-1 sm:gap-1.5">
                        <span className="text-sm sm:text-md font-medium text-gray-700 dark:text-gray-300">
                          Active
                        </span>
                        <div
                          onClick={handleQuestionToggle}
                          role="switch"
                          aria-checked={questionFormData.is_active}
                          className={`relative inline-flex h-4 sm:h-5 w-7 sm:w-9 items-center rounded-full cursor-pointer transition ${
                            questionFormData.is_active
                              ? "bg-blue-600"
                              : "bg-gray-300 dark:bg-gray-600"
                          }`}
                        >
                          <span
                            className={`inline-block h-3 w-3 sm:h-3.5 sm:w-3.5 transform rounded-full bg-white transition ${
                              questionFormData.is_active
                                ? "translate-x-3 sm:translate-x-4"
                                : "translate-x-0.5"
                            }`}
                          />
                        </div>
                      </div>

                      <div className="flex gap-1 sm:gap-1.5">
                        <button
                          type="button"
                          onClick={closeQuestionForm}
                          className="px-2 sm:px-3 py-1 bg-red-600 text-white rounded text-sm sm:text-md font-medium hover:bg-red-700 transition-colors"
                        >
                          Reset
                        </button>
                        <button
                          type="submit"
                          disabled={
                            loading ||
                            (!isQuestionEditing &&
                              (questionsMap[currentAssignment.assignment_id]
                                ?.length || 0) >=
                                currentAssignment.number_of_questions)
                          }
                          className={`px-2 sm:px-3 py-1 bg-[#1f4774] dark:bg-blue-600 hover:bg-blue-700 dark:hover:bg-blue-700 text-white rounded text-sm sm:text-md font-medium flex items-center gap-1 transition ${
                            loading ||
                            (!isQuestionEditing &&
                              (questionsMap[currentAssignment.assignment_id]
                                ?.length || 0) >=
                                currentAssignment.number_of_questions)
                              ? "opacity-50 cursor-not-allowed"
                              : "hover:bg-blue-700"
                          }`}
                        >
                          <FaSave size={12} />
                          {loading
                            ? "Saving..."
                            : isQuestionEditing
                            ? "Update"
                            : "Add"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                {/* QUESTIONS TABLE - 2 PER PAGE */}
                <div>
                  <h3 className="text-sm sm:text-md font-bold text-gray-700 dark:text-gray-300 mb-1 sm:mb-2">
                    Questions List
                  </h3>

                  {questionsMap[currentAssignment.assignment_id]?.length > 0 ? (
                    <>
                      <div className="overflow-x-auto border rounded border-gray-300 dark:border-gray-600">
                        <table className="w-full text-sm sm:text-md border-collapse">
                          <thead>
                            <tr className="bg-[#1f4774] dark:bg-blue-600   text-white">
                              <th className="px-1 sm:px-2 py-1 text-left">
                                S.No
                              </th>
                              <th className="px-1 sm:px-2 py-1 text-left">
                                Question
                              </th>
                              <th className="px-1 sm:px-2 py-1 text-center">
                                Marks
                              </th>
                              <th className="px-1 sm:px-2 py-1 text-center">
                                Ans
                              </th>
                              <th className="px-1 sm:px-2 py-1 text-center">
                                Active
                              </th>
                              <th className="px-1 sm:px-2 py-1 text-center">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {questionsMap[currentAssignment.assignment_id]
                              .slice((currentPage - 1) * 2, currentPage * 2)
                              .map((question, idx) => (
                                <tr
                                  key={question.question_id}
                                  className="border-b dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-300"
                                >
                                  <td className="px-1 sm:px-2 py-1 text-gray-700 dark:text-gray-300">
                                    {(currentPage - 1) * 2 + idx + 1}
                                  </td>
                                  <td
                                    className="px-1 sm:px-2 py-1 max-w-[120px] sm:max-w-[180px] md:max-w-xs truncate text-gray-700 dark:text-gray-300 text-xs sm:text-sm"
                                    title={question.question_name}
                                  >
                                    {question.question_name}
                                  </td>
                                  <td className="px-1 sm:px-2 py-1 text-center text-gray-700 dark:text-gray-300">
                                    {question.marks}
                                  </td>
                                  <td className="px-1 sm:px-2 py-1 text-center font-bold text-green-600 dark:text-green-400">
                                    {question.correct_answer}
                                  </td>
                                  <td className="px-1 sm:px-2 py-1 text-center text-gray-700 dark:text-gray-300">
                                    {question.is_active ? (
                                      <span className="text-green-600 dark:text-green-400">
                                        Yes
                                      </span>
                                    ) : (
                                      <span className="text-red-600 dark:text-red-400">
                                        No
                                      </span>
                                    )}
                                  </td>
                                  <td className="px-1 sm:px-2 py-1 text-center">
                                    <button
                                      onClick={() =>
                                        handleEditSpecificQuestion(
                                          question.question_id,
                                          currentAssignment
                                        )
                                      }
                                      className="text-blue-600 dark:bg-blue-500 hover:text-blue-800 dark:hover:text-blue-500 underline transition-colors duration-300 text-xs sm:text-sm"
                                    >
                                      Edit
                                    </button>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION */}
                      {Math.ceil(
                        (questionsMap[currentAssignment.assignment_id]
                          ?.length || 0) / 2
                      ) > 1 && (
                        <div className="flex flex-col sm:flex-row justify-between items-center mt-2 sm:mt-3 text-sm sm:text-md gap-1 sm:gap-0">
                          <span className="text-gray-600 dark:text-gray-400 text-xs sm:text-sm">
                            Showing {(currentPage - 1) * 2 + 1}–
                            {Math.min(
                              currentPage * 2,
                              questionsMap[currentAssignment.assignment_id]
                                .length
                            )}{" "}
                            of{" "}
                            {
                              questionsMap[currentAssignment.assignment_id]
                                .length
                            }
                          </span>
                          <div className="flex gap-1">
                            <button
                              onClick={() =>
                                setCurrentPage((p) => Math.max(1, p - 1))
                              }
                              disabled={currentPage === 1}
                              className="px-2 sm:px-2.5 py-1 bg-blue-600 dark:bg-blue-500 text-white rounded text-xs sm:text-sm disabled:bg-gray-300 dark:disabled:bg-gray-600 disabled:cursor-not-allowed transition-colors duration-300"
                            >
                              Prev
                            </button>
                            <button
                              onClick={() =>
                                setCurrentPage((p) =>
                                  Math.min(
                                    Math.ceil(
                                      questionsMap[
                                        currentAssignment.assignment_id
                                      ].length / 2
                                    ),
                                    p + 1
                                  )
                                )
                              }
                              disabled={
                                currentPage ===
                                Math.ceil(
                                  questionsMap[currentAssignment.assignment_id]
                                    .length / 2
                                )
                              }
                              className="px-2 sm:px-2.5 py-1 bg-blue-600 dark:bg-blue-500 text-white rounded text-xs sm:text-sm disabled:bg-gray-300 dark:disabled:bg-gray-600 disabled:cursor-not-allowed transition-colors duration-300"
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <p className="text-center text-gray-500 dark:text-gray-400 py-4 sm:py-6 text-sm sm:text-md italic">
                      No questions added yet.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}


{showAssignmentScoreModal && selectedStudentForScores && (
  <div
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-1 sm:p-2"
    onClick={(e) => {
      if (e.target === e.currentTarget) closeAssignmentScoreModal();
    }}
  >
<div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-2xl max-h-[85vh] overflow-y-auto border border-gray-200 dark:border-gray-700 relative transition-colors duration-300">
      <div className="p-2 sm:p-3">
        {/* Close Button */}
        <button
          onClick={closeAssignmentScoreModal}
          className="absolute top-1 right-1 sm:top-2 sm:right-2 text-gray-500 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 transition"
        >
          <FaTimes size={18} />
        </button>
        
        {/* Header */}
        <div className="mb-2">
          <h2 className="text-base sm:text-lg font-bold text-gray-800 dark:text-white pr-6 transition-colors duration-300">
            Assignment Scores
          </h2>
          <p className="text-sm text-gray-700 dark:text-gray-300 mt-0.5 transition-colors duration-300">
            Student: <span className="font-medium">{selectedStudentForScores.first_name} {selectedStudentForScores.last_name}</span>
            {course && (
              <span className="ml-2">
                | Course: <span className="font-medium">{course.course_title}</span>
              </span>
            )}
          </p>
        </div>
        
        {/* Loading State */}
        {loadingScores ? (
          <div className="flex justify-center items-center py-6">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 dark:border-blue-400"></div>
            <span className="ml-2 text-sm text-gray-600 dark:text-gray-300">Loading scores...</span>
          </div>
        ) : (
          <>
            {/* Summary Card - Only show if there are assignments */}
            {allAssignments.length > 0 && (
              <div className="mb-2 p-2 bg-blue-50 dark:bg-blue-900/30 rounded-lg border border-blue-100 dark:border-blue-800 transition-colors duration-300">
                <div className="grid grid-cols-3 gap-1 text-center">
                  <div className="p-1">
                    <div className="text-sm text-blue-700 dark:text-blue-300 font-semibold">Total</div>
                    <div className="text-sm font-bold text-blue-800 dark:text-blue-200">{allAssignments.length}</div>
                  </div>
                  <div className="p-1">
                    <div className="text-sm text-green-700 dark:text-green-300 font-semibold">Attempted</div>
                    <div className="text-sm font-bold text-green-800 dark:text-green-200">
                      {assignmentScores.filter(score => score.has_result).length}
                    </div>
                  </div>
                  <div className="p-1">
                    <div className="text-sm text-yellow-700 dark:text-yellow-300 font-semibold">Not Attempted</div>
                    <div className="text-sm font-bold text-yellow-800 dark:text-yellow-200">
                      {assignmentScores.filter(score => !score.has_result).length}
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {/* Assignment Scores Table - Horizontal scroll on small/medium screens */}
            <div className="overflow-x-auto rounded border border-gray-200 dark:border-gray-700 transition-colors duration-300">
              <div className="min-w-[500px] sm:min-w-full">
                <table className="w-full">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th className="px-2 py-1.5 text-center text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase whitespace-nowrap">
                        S.No
                      </th>
                      <th className="px-2 py-1.5 text-left text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase whitespace-nowrap">
                        Assignment Name
                      </th>
                      <th className="px-2 py-1.5 text-center text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase whitespace-nowrap">
                        Score
                      </th>
                      <th className="px-2 py-1.5 text-center text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase whitespace-nowrap">
                        Result On
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                    {assignmentScores.length > 0 ? (
                      assignmentScores.map((score, index) => (
                        <tr 
                          key={score.assignment_id} 
                          className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors duration-150"
                        >
                          <td className="px-2 py-1.5 text-center text-sm text-gray-700 dark:text-gray-300 whitespace-nowrap">
                            {index + 1}
                          </td>
                          <td className="px-2 py-1.5 text-sm text-gray-700 dark:text-gray-300 truncate max-w-[150px]">
                            {score.assignment_name}
                          </td>
                          <td className="px-2 py-1.5 text-center whitespace-nowrap">
                            {score.has_result ? (
                              <div className="flex flex-col items-center justify-center">
                                <span className={`text-sm font-bold ${
                                  score.pass_marks >= score.qualify_marks 
                                    ? "text-green-600 dark:text-green-400" 
                                    : "text-red-600 dark:text-red-400"
                                }`}>
                                  {score.pass_marks}/{score.total_marks}
                                </span>
                              </div>
                            ) : (
                              <span className="text-sm text-gray-500 dark:text-gray-400">N/A</span>
                            )}
                          </td>
                          <td className="px-2 py-1.5 text-center whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                            {score.has_result && score.result_created_date 
                              ? formatDate(score.result_created_date)
                              : <span className="text-sm text-gray-500 dark:text-gray-400">N/A</span>
                            }
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="px-2 py-4 text-center">
                          <div className="flex flex-col items-center justify-center py-2">
                            <svg className="w-6 h-6 text-gray-400 dark:text-gray-500 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            <p className="text-sm text-gray-500 dark:text-gray-400">
                              No assignments found for this course.
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            
            {/* Empty State - only show if no assignments at all */}
            {allAssignments.length === 0 && !loadingScores && (
              <div className="text-center py-4">
                <svg className="w-8 h-8 text-gray-400 dark:text-gray-500 mx-auto mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-0.5">
                  No assignments available for this course.
                </p>
                <p className="text-sm text-gray-400 dark:text-gray-500">
                  Create assignments in the Assignments tab first.
                </p>
              </div>
            )}
          </>
        )}
        
        {/* Close Button at Bottom */}
        <div className="flex justify-end mt-2 pt-2 border-t border-gray-200 dark:border-gray-700 transition-colors duration-300">
          <button
            onClick={closeAssignmentScoreModal}
            className="px-2 py-1 bg-gray-300 dark:bg-gray-600 hover:bg-gray-400 dark:hover:bg-gray-500 text-gray-800 dark:text-gray-300 rounded transition-colors font-medium text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}



{/* Project Details Modal – Super Clean & Exact Format */}
{showProjectDetailsModal && selectedStudentProject && (
  <div
    className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4"
    onClick={() => setShowProjectDetailsModal(false)}
  >
    <div
      className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-2xl max-h-[92vh] overflow-y-auto"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header */}
      <div className="bg-[#1f4774] dark:bg-blue-600 text-white px-6 py-5 rounded-t-xl flex justify-between items-center">
        <h2 className="text-xl font-bold">Project Details</h2>
        <button
          onClick={() => setShowProjectDetailsModal(false)}
          className="text-white hover:text-gray-200 transition"
        >
          <FiX size={26} />
        </button>
      </div>

      <div className="p-6 space-y-6 text-sm">

<div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">

  {/* Project Title */}
  <div className="flex">
    <p className="min-w-40 font-medium text-gray-600 dark:text-gray-400">
      Project Title :
    </p>
    <p className="font-semibold text-gray-800 dark:text-white">
      {selectedStudentProject.project_title ||
        selectedStudentProject.project_name ||
        "Not Submitted"}
    </p>
  </div>

  {/* Source Code */}
  <div className="flex">
    <p className="min-w-40 font-medium text-gray-600 dark:text-gray-400">
      Source Code :
    </p>
    {selectedStudentProject.project_source_link ? (
      <a
        href={selectedStudentProject.project_source_link}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 dark:text-blue-400 hover:underline font-medium"
      >
        View Source
      </a>
    ) : (
      <span className="text-gray-500 italic">No link provided</span>
    )}
  </div>

  {/* Submission Status */}
  <div className="flex">
    <p className="min-w-40 font-medium text-gray-600 dark:text-gray-400">
      Submission Status :
    </p>
    <span
      className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
        selectedStudentProject.project_is_active
          ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
          : "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-400"
      }`}
    >
      {selectedStudentProject.project_is_active ? "Submitted" : "Not Submitted"}
    </span>
  </div>

  {/* Review Status */}
  <div className="flex">
    <p className="min-w-40 font-medium text-gray-600 dark:text-gray-400">
      Review Status :
    </p>
    <span
      className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
        selectedStudentProject.is_review === 1
          ? "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200"
          : "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300"
      }`}
    >
      {selectedStudentProject.is_review === 1 ? "Reviewed" : "Pending"}
    </span>
  </div>

</div>


        {/* Output Images */}
        <div>
          <h4 className="font-bold text-gray-800 dark:text-white mb-4 text-base">
            Output Images
          </h4>
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-4">
            {[1, 2, 3, 4, 5].map((num) => {
              const imgKey = `output_image${num}`;
              const imgUrl = selectedStudentProject[imgKey]
                ? formatImageUrl(selectedStudentProject[imgKey])
                : null;

              return (
                <div key={num} className="relative group">
                  {imgUrl ? (
                    <a
                      href={imgUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block rounded-lg overflow-hidden border-2 border-gray-300 dark:border-gray-600 shadow hover:shadow-xl transition-all duration-200"
                    >
                      <img
                        src={imgUrl}
                        alt={`Output ${num}`}
                        className="w-full h-28 object-cover"
                      />
                      <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition flex items-center justify-center">
                        <span className="text-white font-medium opacity-0 group-hover:opacity-100">
                          View Full
                        </span>
                      </div>
                    </a>
                  ) : (
                    <div className="bg-gray-100 dark:bg-gray-700 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg h-28 flex items-center justify-center">
                      <span className="text-gray-400 text-sm">No Image</span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Close Button */}
        <div className="flex justify-end pt-5 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={() => setShowProjectDetailsModal(false)}
            className="px-7 py-3 bg-[#1C3664] text-white rounded-lg hover:bg-blue-700 transition text-base font-medium shadow-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}






      </div>
    </div>
  );
};

export default InstructorCurriculum;
